import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Constants from "../../Constants";
import Select from "react-select";
import ReactMultiSelect from "../../components/global/ReactMultiSelect";
import {
  getAxiosResponse,
  postAxiosFormDataResponse,
  downloadFile,
  postAxiosResponse,
  putAxiosResponse,
  deleteAxiosResponse,
} from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import {
  checkFileSizeInGb,
  dateConvertToTimeStamp,
  dateFormatAndStatus,
  formatBytes,
  openNewTab,
  transformBlankToNull,
} from "../../services/Util";
import { PROJECT_DATE_FORMAT } from "../../services/Util";
import { useDispatch, useSelector } from "react-redux";
import { updateSourceFiles } from "../../redux/reducers/SourceFilesSlice";
import CustomProgressBar from "../../components/global/CustomProgressBar";
import { RotatingLines } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import $, { data } from "jquery";
import SuccessMessage from "../../components/SuccessMessage";
import ReactTooltip from "react-tooltip";
import { confirmAlert } from 'react-confirm-alert';
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { projectCreationStepFilter } from "../../redux/reducers/ProjectCreationStepSlice";
import { updateProjectFollowers, updateProjectInfo, updateSourceLanguage, updateTargetLanguage } from "../../redux/reducers/ProjectInfoSlice";
import { departmentSelected } from "../../redux/reducers/SelectDropDownSlice";
import { updateInitializedProjectWorkflows } from "../../redux/reducers/InitializedProjectWorkflowsSlice";
import { updateProjectInfoValidation } from "../../redux/reducers/ProjectInfoValidationSlice";
import { updateProjectInfoConfiguration } from "../../redux/reducers/ProjectInfoConfigurationSlice";
import { handleError } from "../../services/authApiRoutes/APImethods";
import DateFormat from "../DateFormat";
import dateUtil, {DATE_FORMATS} from "../../services/DateUtil";

export default function Reference() {
  const [globalOverlay, showGlobalOverlay] = useState(true);
  const scrollRef = useRef(null);
  const paginationRef = useRef();
  const { t } = useTranslation();
  const [department, setDepartment] = useState([]);
  const translate = t;
  const [activeTab, setActiveSection] = useState("manage");
  const [active, setactive] = useState("");
  const [departments, updatedDepartment] = useState([]);
  const [glossaryDep, setGlossaryDepartment] = useState([]);
  const [depGroup, setDepGroup] = useState([]);
  const [customer, setCustomer] = useState({});
  const [customerUser, setCustomerUser] = useState([]);
  const [permission, setPermission] = useState({});
  const [feature, setFeatures] = useState({});
  const [tm, setTm] = useState({});
  const [depId, setDepId] = useState(null);
  const [browseGlossaryData, setBrowseGlossary] = useState([]);
  const [glossaryLanguage, setGlossaryLanguage] = useState([]);
  const [selectedSourceLanguage, setSelectedSourceLanguage] = useState([]);
  const [columns, setColumns] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, updateCurrentPage] = useState(1);
  const [details, setDetails] = useState({});
  const [termsLanguages, setTermLanguages] = useState([]);
  const [status, setStatus] = useState(false);
  const [sourceTerm, setSourceTerm] = useState(null);
  const [partOfspeech, setPartOfspeech] = useState(null);
  const [notes, setNotes] = useState(null);
  const [statusSourceTerm, setStatusSourceTerm] = useState(null);
  const [selectSourceTerms, selectedSourceTerms] = useState([]);
  const [selectedTags, setSelectedTag] = useState([]);
  const [departmentGlossaryLanguage, setDepartmentGlossaryLanguage] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState([]);
  const [allLanguage, setAllLanguage] = useState([]);
  const [containWord, setContainWord] = useState('');
  const [partOfSpeechFilter, setPartOfSpeechFilter] = useState(null)
  const [lastUpdateDate, setLastUpdateDate] = useState(null)
  const [termStatus, setTermStatus] = useState(null)
  const [translationLanguage, setTranslationLanguage] = useState(null)
  const [user, setUser] = useState(null)
  const [urlData, setUrlData] = useState(null)
  const [size, setSize] = useState(15)
  const [sourceData, setSourceData] = useState(null)
  const [loader, showLoader] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [glossaryDepartmentData, setGlossaryDepartmentData] = useState([])
  const [fileUploadRes, setFileUploadResponse] = useState("")
  const [uploadStatus, setUploadStatus] = useState("")
  const [lasChunkStatus, setLasChunkStatus] = useState(false)
  const [tableDataStatus, setTableDataStatus] = useState({ seq: "0", status: false, display: "" })
  const [translationText, setTranslationText] = useState("")
  const [translationNote, setTranslationNote] = useState("")
  const [languageTranslationText, setLanguageTranslationText] = useState("")
  const [partOfSpeechTranslation, setPartOfSpeechTranslation] = useState({})
  const [popStatus, setPopopStatus] = useState({ seq: "", status: false, display: "" })
  const [startPage, setStartPage] = useState("&start=0")
  const [conditionalpopup, setconditionalpopup] = useState(false);
  const [deptNeedsUpdate, setDeptNeedsUpdate] = useState({});
  const [intendendUseTaskData, setIntendedUseTask] = useState([{}])
  //upload file
  const [selectedfile, setSelectedFile] = useState("");
  const [files, setFiles] = useState([]);
  const [documentVariant, setDocumentVariant] = useState();
  const [currentFileIndex, setCurrentFileIndex] = useState(null);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const fileQueue = useRef([]);
  const [showError, setError] = useState(false);
  const [errorRes,setErrorRes]=useState({error:"",index:"",col:""})
  const chunkSize = Constants.CHUNK_SIZE;
  const [successMessage, setSuccessMessage] = useState(Constants.BLANK);
  const [valueForMultiSelect,setValueForMultiSelect] = useState([])
  const [collectionExist,setCollectionExist] = useState(false);
  const [collectionExistErrorMessage,setCollectionExistErrorMessage] = useState("");
  const [styleGuide,setStyleGuideData]=useState("")
  const [styleGuideName,setStyleGuideDataName]=useState("")
  const [fileDepartmentId,setFileDepartmentId]=useState(null)
  const [sourceErrorMsg,setSourceErrorMessage]=useState("")
  const [fileUploadPermission,setFileUploadPermission]=useState(false)
  const navigate=useNavigate();
  const accountPermission = useSelector(
    (updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data,
  ).value;
  const multiSelectRef = useRef(null);
  const multiSelectRef1 = useRef(null);
  const [rightModelStatus, setRightModelStatus] = useState(false)
  const [fileUploadStatus,setFileUploadStatus]=useState(false);
  const [updatedStatus,setUpdatedStatus]=useState({label:"",value:""})
  const [termLanguageColumns,setTermLanguagesColumns]=useState([])
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  //master data 
  const partOfSpeechFilterList = [
    { label: "adjective", value: "ADJECTIVE" },
    { label: "adverb", value: "ADVERB" },
    { label: "none", value: "NONE" },
    { label: "noun", value: "NOUN" },
    { label: "phrase", value: "PHRASE" },
    { label: "proper noun", value: "PROPER_NOUN" },
    { label: "verb", value: "VERB" },
    { label: "other", value: "OTHER" },
  ];


  const transaltionType = [
    {label: translate("task_campaign.check_all"),value: "all"},
    {label: translate("task_campaign.uncheck_all"),value: "none"},
    { label: "Translated terms", value: "HAS_TRANSLATION" },
    { label: "Untranslated terms", value: "NO_TRANSLATION" },
    { label: "Out-of-date terms", value: "NEEDS_UPDATE" },
  ];


  useEffect(()=>{

    if(collectionExist){
      getGlossaryLanguage();
      getGlossary();
      getStyleGuide();
      projectCompleted();
      projectBrowse();
      getCustomerUser();
      getCustomer();
      getCustomerPermission();
      getIntendendUseTask()
      $('.lastdisable').trigger('focus');
  }
  },[collectionExist])

  useEffect(()=>{
    if (successMessage === Constants.BLANK) {
      $('.lastdisable').trigger('focus');
    }
  },[successMessage])
  //use effects
  useEffect(() => {
    getNeedUpdate();
    $(document).on("click keydown",'.circle',function(e) {
      if (e.type === "click" || e.key === Constants.ENTER || e.keyCode === 32) {
        $(this).parent().toggleClass('addFocus');
      }
    });
  }, []);
  
  useEffect(() => {
    $(document).ready(function(){
      setTimeout(() => {
        $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1");
        $('.rdt_Table').attr('aria-label', 'Reference');
      }, 500);
     })
  }, [browseGlossaryData]);

  useEffect(() => {
    if(collectionExist){
    getAvailableDepartment();
    glossaryDepartment();
    }
  }, [tm])

  useEffect(() => {
      departmentData();
  }, [departments, glossaryDep]);

  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1");
    $(".rdt_Table").attr("aria-label","Project Tasks");
    $('.rdt_Table input').parent().attr("role","cell")
  })

  useEffect(() => {
    const lang = glossaryLanguage.filter(
      (data) => data?.userGroup?.id === depId
    );
    if (lang && lang.length > 0) {
      const col = lang[0]?.termLanguage.map((res) => {
        return {
          label: res.displayName,
          value: res.code,
        };
      });
      setDepartmentGlossaryLanguage(col?.sort((a, b) => a?.label?.localeCompare(b?.label)));
      setDepartmentGlossaryLanguage(current => [{
        label: translate("task_campaign.check_all"),
        value: "all",
      },{
        label: translate("task_campaign.uncheck_all"),
        value: "none",
      }, ...current]);
      setAllLanguage([...col, { label: lang?.sourceLanguage?.display, value: lang?.sourceLanguage?.code }])
    }
  }, [depId]);

   useEffect(()=>{
    setDepId(tm?.userGroup?.id)
   },[tm])

  useEffect(() => {
    if (currentFileIndex !== null) {
      setCurrentChunkIndex(0);
    }
  }, [currentFileIndex]);

  useEffect(() => {
    if (currentChunkIndex !== null) {
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);


  $('#search-btn,  #AdditionalFilter').on('blur', function (e) {
    $('#search-btn').removeAttr('aria-labelledBy');
    $('#AdditionalFilter').removeAttr('aria-labelledBy');
  });

  // All Filters
  useEffect(() => {
    let url = ""
    if (depId !== null) {
      url = url + "depId=" + depId
    }
    if (selectedLanguage.length > 0) {
      const data = selectedLanguage.map(data => "&trg=" + data.value)
      url = url + data.join("")
    }
    if (selectedTags.length > 0) {
      const data = selectedTags.map(data => "&ht=" + data)
      url = url + data.join("")
    }
    if (partOfSpeechFilter !== null) {
      url = url + "&pos=" + partOfSpeechFilter?.value
    }
    if (lastUpdateDate !== null) {
      url = url + "&dt=" + lastUpdateDate?.value
    }
    if (termStatus !== null) {
      url = url + "&ts=" + termStatus?.value
    }
    if (containWord !== '' && containWord !== null) {
      url = url + "&text=" + containWord
      if (translationLanguage !== null) {
        url = url + "&stl=" + translationLanguage?.value
      }
    }
    else{
      setTranslationLanguage(null)
    }
    
    if (user !== null) {
      url = url + "&cUser=" + user?.value?.userId
    }
    setUrlData(url)
  }, [selectedLanguage, depId, selectedTags, partOfSpeechFilter, lastUpdateDate, termStatus, containWord, translationLanguage, user])




  //Model related stuff
  const termDetailsKeydown = (event) => {
    if (event.key === Constants.TAB) {
      event.preventDefault();
      $('.close').trigger('focus');
    } else if (event.key === Constants.ESCAPE) {
      hideModel();
    }
  } 
  const keydownshowModel = (event, index) => {
    if (event.key === Constants.TAB && !event.shiftKey &&
      $('.circle.active .inner-popover').find('button:last').is(':focus')) {
      if(active){
        setactive(false);
      }
      event.preventDefault();
      $(event.target).closest('.circle').trigger('focus');
      $('.addFocus').removeClass('addFocus');
    }
  }

  const keydownDetails = (event, index) => {
    if (event.key===Constants.ENTER) {
      showModel(index);
    }
  }
  const showModel = (index) => {
    setconditionalpopup(true);
    setLanguages(index);
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(document.activeElement).closest('.circle').parent().addClass('addFocus');
      $('.close').trigger('focus');
    }, 300);
  };

  const hideModel = () => {
    document.body.classList.remove("modal-open");
    $('.addFocus .circle').trigger('focus');
    $('.addFocus').removeClass('addFocus');
  };


  const hideModalReference = (fetchData) => {
    if (fetchData) {
      setSuccessMessage(Constants.GLOSSARY_SUCCESS_MESSAGE);
      glossaryDepartment();
      getStyleGuide()
    }
    setFileUploadResponse("");
    setUploadStatus("")
    setSelectedFile("");
    document.body.classList.remove("modal-open");
  };
  const keydownhandling = (event) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      event.preventDefault();
      hideModalReference(true);
    }
    if (event.key === Constants.TAB &&  event.shiftKey === false) {
      event.preventDefault();
      $("#hideNewTermModal").trigger("focus");
    }
  };
  const rightModel = () => {
    setRightModelStatus(true);
    document.body.classList.add("right-modal-open");
    setTimeout(() => {
      $(".closeAdditionalFilter").trigger("focus");

      $("#cancelRightModal").on("keydown", function (e) {
        const ccwSaveBtn = $("#additionSaveBtn")[0];
        if (e.key !== Constants.TAB) {
          return
        }
        e.preventDefault();
        if (ccwSaveBtn.disabled) {
          $(".closeAdditionalFilter").trigger("focus");
        } else {
          $("#additionSaveBtn").trigger("focus");
          $("#additionSaveBtn").on("keydown", function (e) {
            if (e.key === Constants.TAB) {
              e.preventDefault();
              $(".closeAdditionalFilter").trigger("focus");
            }
          })
        }
      })
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModel();
          $('.focusAdd').trigger('focus');
          $('.lastBtn').removeClass('focusAdd');
        }
      });
      
      $(".onetm-right-modal").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE && $(document.activeElement).attr('aria-expanded') !== 'true') {
          hideRightModel();
        }
      });
    }, 500);
  };

  const hideRightModel = () => {
    setRightModelStatus(false);
    document.body.classList.remove("right-modal-open");
    $('#AdditionalFilter').trigger('focus');
  };

  const applyButtonClick = () => {
    getBrowseGlossary(1, size);
    hideRightModel()
  }


  //api calls
  const getAvailableDepartment = () => {
    getAxiosResponse(APIUrls?.AVAILABLE_DEPARTMENTS)
      .then((res) => {
        if (res?.data?.data && res?.data?.data?.length > 0) {
          setDepartment(res?.data?.data);
          const result = res?.data?.data?.map((data) => {
            return {
              label: data?.name + " " + "Glossary",
              value: data?.id,
            };
          });
          result.unshift({ label: "Company", value: tm?.userGroup?.id })
          updatedDepartment(result);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  //GLOSSARY  Language

  const getGlossaryLanguage = () => {
    getAxiosResponse(APIUrls.GLOSSARY_LANGUAGE)
      .then((res) => {
        if (res?.data?.data) {
          setGlossaryLanguage(res?.data?.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };


  //glossary

  const getGlossary = () => {
    getAxiosResponse(APIUrls.GLOSSARY)
      .then((res) => {
        if (res?.data?.data) {
          setTm(res?.data?.data?.body);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  //glossary department
  const glossaryDepartment = () => {
    getAxiosResponse(APIUrls.GLOSSARY_DEPARTMENT)
      .then((res) => {
        if (res?.data) {
          setGlossaryDepartment(res?.data);
          const resFinal = res?.data?.map(data => {
            return {
              label: data?.userGroup?.name + " " + "Glossary",
              value: data?.userGroup?.id
            }
          })
          resFinal.unshift({ label: "Company Glossary", value: tm?.userGroup?.id })
          setGlossaryDepartmentData(resFinal)
          setSuccessMessage(Constants.BLANK)
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };


  const getIntendendUseTask = async () => {
    const dateTimestamp = dateConvertToTimeStamp();
    let timeStamp = '?_=' + dateTimestamp
    const intendendUseTask = await getAxiosResponse(APIUrls.INTENDED_USES_TASKS + timeStamp)
    if(intendendUseTask?.data?.data && intendendUseTask?.data?.data?.length > 0){
      const intendendUseTaskData = 
      intendendUseTask?.data?.data.map(({ id, name, tasks}) => ({
        label: name,
        value: name,
        id: id,
        tasks: tasks
      }));
      if (intendendUseTaskData) {
        intendendUseTaskData.unshift({
          label: 'Select one',
          value: 0,
          id: 0
        })
      }
      setIntendedUseTask(intendendUseTaskData)
    }
  }


  // need Update
  const getNeedUpdate = () => {
    getAxiosResponse(APIUrls.NEED_UPDATE)
      .then((res) => {
        if (res?.data) {
          if(res?.data?.data!=undefined){
            setDeptNeedsUpdate(res?.data?.data)
            setCollectionExist(true);
          }
          else if(res?.data?.handledMessage!==undefined)
          {
            setCollectionExist(false);
            setCollectionExistErrorMessage(res?.data?.handledMessage)
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const checkOutOfDate = (depId) => {
    if (deptNeedsUpdate !==undefined &&  deptNeedsUpdate[depId] !== undefined) {
      return deptNeedsUpdate[depId]
    }
    return 0;
  }
  //project completed

  const projectCompleted = () => {
    getAxiosResponse(APIUrls.PROJECT_COMPLETED)
      .then((res) => { })
      .catch((err) => {
        handleError(err);
      });
  };

  //project browse
  const projectBrowse = () => {
    getAxiosResponse(APIUrls.PROJECT_BROWSE)
      .then((res) => { })
      .catch((err) => {
        handleError(err);
      });
  };

  const getCustomerUser = () => {
    getAxiosResponse(APIUrls.CUSTOMER_USER)
      .then((res) => {
        if (res?.data?.data) {
          const result = res?.data?.data?.map((data) => {
            return {
              label: data?.firstName + " " + data?.lastName,
              value: data,
            };
          });
          setCustomerUser(result);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  $('.tooltipRef').on('keydown', function(e){
    if(e.key === Constants.ESCAPE){
      $(this).removeAttr('aria-describedby')
      $(this).next().removeClass('show')
    }
  });
  const getCustomerPermission = () => {
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA)
      .then((res) => {
        setPermission(res?.data?.data?.permissions);
        setFeatures(res?.data?.data?.features);
      })
      .catch((err) => {
        handleError(err);
      });
  };

  $(document).on("click",".lastBtn",function() {
    $(this).addClass('focusAdd');
 });
 $(document).on("click",".close",function() {
   $('.focusAdd').trigger('focus');
   $('.lastBtn').removeClass('focusAdd');
 });
  const createTerm = (id) => {
    setconditionalpopup(false);
    setFileUploadPermission(false)
    setFileUploadResponse("");
    if (id !== undefined) {
      setFileDepartmentId(id);
    }
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB &&  e.shiftKey === false) {
          e.preventDefault();
          if(!$('#valid-upload').hasClass("disabled")){
            $("#valid-upload").trigger("focus");
          } else if($('#hideUploadModal').length) {
            $("#hideUploadModal").trigger("focus");
          } else {
            $("#hideNewTermModal").trigger("focus");
          }
          $("#hideNewTermModal").on("keydown", function (e) {
            if (e.key === Constants.TAB && e.shiftKey === true) {
              e.preventDefault();
                $(".first-focus").trigger("focus");
            }
            if (e.key === Constants.TAB && e.shiftKey === true) {
              e.preventDefault();
              if(!$('#valid-upload').hasClass("disabled")){
                $("#valid-upload").trigger("focus");
              } else if ($('#hideUploadModal').length) {
                $("#hideUploadModal").trigger("focus");
              }
            }
          });
          $("#valid-upload").on("keydown", function (e) {
            if (e.key === Constants.TAB &&  e.shiftKey === false) {
              e.preventDefault();
              $("#hideNewTermModal").trigger("focus");
            }
          });
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModalReference(false);
          $('.focusAdd').trigger('focus');
          $('.lastBtn').removeClass('focusAdd');
        }
      });
    }, 500);
  };


  
  const deleteTranslateLanguage=(row,code,lang)=>{
    let targetLanguages=row?.langTerms?.filter(data=>data.language===code)[0]
    let obj={"id":row?.id,"oldText":targetLanguages.text,"groupId":row?.departmentId,"language":lang.display,"delete":true}
    showGlobalOverlay(true)
    putAxiosResponse(APIUrls.PROJECT_BROWSE,obj)
    .then((res) => { 
      showGlobalOverlay(false)
      getBrowseGlossary(1, size)
    })
    .catch((err) => {
    showGlobalOverlay(false)
      handleError(err);
    });
  }

  const keydownBidOutOfDateSet = (event, row, res) => {
    if (event.key === Constants.ENTER) {
      bidOutOfDateSet(row,res?.code,res);
    }
  }

  const bidOutOfDateSet=(row,code,lang)=>{
    let targetLanguages=row?.langTerms?.filter(data=>data.language===code)[0]
    let obj={"id":row?.id,"oldText":targetLanguages?.text,"groupId":row?.departmentId,"language":lang?.display,"outdated":false}
    showGlobalOverlay(true)
    putAxiosResponse(APIUrls.PROJECT_BROWSE,obj)
    .then((res) => { 
      showGlobalOverlay(false)
      getBrowseGlossary(1, size)
    })
    .catch((err) => {
    showGlobalOverlay(false)
      handleError(err);
    });
  }
  $('.tableTextarea').on('keydown', function(e) {
    if (e.key===Constants.ESCAPE) {
      setTableDataStatus({ seq: "", status: false });
    }
  })
  useEffect(()=>{
    if ($('.tableTextarea').length) {
      const elem = $(document.activeElement).closest('.addFocus');
      setTimeout(() => {
        elem.find('.circle').prev().find('a').trigger('focus');
        $('.addFocus').removeClass('addFocus');
      }, 500);
      }
  }, [tableDataStatus]);

  useEffect(() => {
    let lang = glossaryLanguage.filter(
      (data) => data?.userGroup?.id === depId
    );
    if (lang[0]?.termLanguage && lang[0]?.termLanguage?.length > 0) {
    let columns=[]
      lang[0]?.termLanguage?.forEach(data=>{
        termLanguageColumns?.forEach(termLanguageFound=>{
            if(data?.display===termLanguageFound){
              columns?.push(data)
              
            }
        })
      })
      
      setSelectedSourceLanguage(lang[0])
      const col = columns?.sort((a, b) => a?.displayName?.localeCompare(b?.displayName))?.map((res) => {
        return {
          name: res.displayName,
          id: res.display,
          selector: (row, index) => (
            <>
              {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus?.display === res?.display ? <div className="flex justify-center tableTextarea">
                <div className="w-d100 mar-bot14">
                  <textarea maxLength={250} onChange={e => setLanguageTranslationText(e?.target?.value !==""?e?.target?.value:"")} className="textarea" defaultValue={languageTranslationText} />
                          <small>{isNaN(250 - languageTranslationText?.length ) ? (250 -    languageTranslationText?.length) : 250 - languageTranslationText?.length} characters left</small>
                </div>
                <div className="flex btn-gap">
                  <button onClick={() => updateGlossary("", index, res)} className="blue-btn">Save</button>
                  <button onClick={() => setTableDataStatus({ seq: "", status: false })} className="blue-btn active">Cancel</button>
                </div>
              </div> :

                <div className="refrence-cell"
                onClick={() => setNewSourceTermStatus(index, res?.code, res?.display,'lang')}
                 >{getColumnData("lang", res?.code, index)?<div className="refrence-cell" onClick={() => columnClick(index, res.display)}><Link   tabIndex={ getColumnData("lang", res?.code, index) ? '0' : '-1' }>
                  {getColumnData("lang", res?.code, index)}</Link></div>:Constants.BLANK}</div>
                }
              {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus?.display === res?.display ? "" :
                <div
                  className={active ? "circle active" : "circle"}
                  onClick={() => openInformationDialog(index, res?.display, res?.code, "lang")}
                  onKeyDown={(e) => keydownOpenInformationDialog(e, index, res, "lang")}
                  role="button"
                  aria-expanded={active? "true" : "false"}
                  aria-label="More options"
                  tabIndex="0"
                >
                  <div className="dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div className="blankbg"></div>
                  {popStatus.seq === index && popStatus.status && popStatus.display === res?.display ?
                    <div className={active ? "popover-body show" : "popover-body"}
                    onKeyDown={(e) => keydownshowModel(e)}
                    >
                      <div className="inner-popover">

                         {languageTranslationText?.length > 0 ?<>
                         {row?.langTerms.filter(data=>data.language===res?.code)[0]?.outdated?
                        <button onClick={() => bidOutOfDateSet(row,res?.code,res)} onKeyDown={(e) => keydownBidOutOfDateSet(e, row, res)} aria-label="Edit">Mark up-to-date</button>:Constants.BLANK}
                        <button onClick={() => columnClick(index, res.display)} onKeyDown={(e) => diffLangcolumnClick(e, index, res)} aria-label="Edit">Edit</button>
                        <button
                            aria-label="Search in Tm"
                            onClick={() => searchInTmTargetLanguage(translationText,lang[0]?.sourceLanguage?.code,depId,res?.code)}
                            onKeyDown={(e) => keydownSearchInTmTargetLanguage(e, translationText, lang, depId, res)}
                          >
                            Search In Tm
                          </button>
                        <button
                          aria-label="Details"
                          onClick={() => showModel(index)}
                          onKeyDown={(e) => keydownDetails(e, index)}
                        >
                          Details
                        </button>
                        <button
                          aria-label="Details"
                          onClick={() =>deleteTargetLanguageData(row,res?.code,res)}
                          onKeyDown={(e) =>keydowndeleteTargetLanguageData(e, row, res)}
                        >
                          Delete
                        </button>
                        </>:
                        <button onClick={() => columnClick(index, res.display)} onKeyDown={(e) => diffLangcolumnClick(e, index, res)} aria-label="Edit">Edit</button>
                        }
                      </div>
                    </div> : ""}
                </div>}
            </>
          ),
        };
      });

      setColumns([
        ...[
          {
            id: lang[0]?.sourceLanguage?.display,
            name: lang[0]?.sourceLanguage?.displayName,
            selector: (row, index) => (
              <>
                {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus.display === lang[0]?.sourceLanguage?.display ?
                  <div className="flex justify-center tableTextarea">
                    <div className="w-d100 mar-bot14">
                      <textarea className="textarea" onChange={(e) => setTranslationText(e.target.value)} defaultValue={translationText} />
													<small>{isNaN(250 - translationText?.length ) ? (250 -    translationText?.length) : 250 - translationText?.length} characters left</small>
                    </div>
                    <div className="flex btn-gap">
                      <button id="saveSourceBtn" onClick={() => updateGlossary("source", index)} className="blue-btn">Save</button>
                      <button id="cancelSourceBtn" onClick={() =>{setTableDataStatus({ seq: "", status: false });setErrorRes("")}} className="blue-btn active">Cancel</button>
                    </div>
                  </div> :
                  <div className="refrence-cell"
                    onClick={() => setNewSourceTermStatus(index, lang[0]?.sourceLanguage?.code, lang[0]?.sourceLanguage?.display,'source')}
                  > 
                   {getColumnData(
                      "source",
                      lang[0]?.sourceLanguage?.code,
                      index
                    )?<div onClick={() => columnClick(index, lang[0]?.sourceLanguage?.display)}>
                    <Link 
                    data-tip={getColumnCurrentStatus(index)==='needs_review_term' ? 'Needs Review':getColumnCurrentStatus(index) ==='approved_term'?'Approved':'Rejected' }
                    data-for={`source${index}`} className={getColumnCurrentStatus(index) + " tooltipRef"} onClick={() => columnClick(index, lang[0]?.sourceLanguage?.display)}
                    tabIndex={getColumnData("source",lang[0]?.sourceLanguage?.code,index) ? '0' : '-1'}>
                     { errorRes?.index===index && errorRes?.col==="source"?"" :getColumnCurrentStatus(index) ==='approved_term' && <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 23 23" fill="none"><rect width="23" height="23" rx="11.5" fill="#52CE25"></rect><path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>  
                      </span>}
                      {errorRes?.index===index && errorRes?.col==="source"?"": getColumnCurrentStatus(index) ==='needs_review_term' && <span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#e18016" stroke-width="1.4"></circle><rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#e18016"></rect></svg>
                        </span>}
                      { errorRes?.index===index && errorRes?.col==="source"?"": getColumnCurrentStatus(index) ==='rejected_term' && <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#e00e0e"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="#e00e0e"></path></svg>
                        </span>}
                      {getColumnData(
                      "source",
                      lang[0]?.sourceLanguage?.code,
                      index
                    )}</Link>
                    </div>:Constants.BLANK}
                  
                   {errorRes?.index===index && errorRes?.col==="source" && 
                <div>
                 <p className="flex flex-nowrap"><svg
                                        className="aaa-change-icon wd35"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="25"
                                        viewBox="0 0 25 25"
                                        fill="none"
                                      >
                                        <path
                                          d="M12.5003 4.16602C10.8522 4.16602 9.24099 4.65476 7.87058 5.57044C6.50017 6.48611 5.43206 7.7876 4.80133 9.31032C4.1706 10.833 4.00558 12.5086 4.32712 14.1251C4.64866 15.7416 5.44234 17.2265 6.60777 18.3919C7.77321 19.5573 9.25807 20.351 10.8746 20.6726C12.4911 20.9941 14.1666 20.8291 15.6894 20.1983C17.2121 19.5676 18.5136 18.4995 19.4292 17.1291C20.3449 15.7587 20.8337 14.1475 20.8337 12.4993C20.8337 10.2892 19.9557 8.1696 18.3929 6.60679C16.8301 5.04399 14.7105 4.16602 12.5003 4.16602ZM12.5003 19.4438C11.1268 19.4438 9.78421 19.0365 8.6422 18.2734C7.50019 17.5104 6.61011 16.4258 6.0845 15.1569C5.55889 13.8879 5.42137 12.4916 5.68932 11.1446C5.95727 9.79747 6.61867 8.56008 7.58987 7.58889C8.56106 6.61769 9.79845 5.95629 11.1455 5.68834C12.4926 5.42039 13.8889 5.55791 15.1579 6.08352C16.4268 6.60913 17.5114 7.49921 18.2744 8.64122C19.0375 9.78323 19.4448 11.1259 19.4448 12.4993C19.4448 13.4113 19.2652 14.3143 18.9162 15.1569C18.5672 15.9994 18.0556 16.765 17.4108 17.4098C16.7659 18.0547 16.0004 18.5662 15.1579 18.9152C14.3153 19.2642 13.4123 19.4438 12.5003 19.4438Z"
                                          fill="#64748B"
                                        />
                                        <path
                                          d="M12.5004 17.0621C12.261 17.0621 12.0314 16.967 11.8621 16.7976C11.6928 16.6283 11.5977 16.3987 11.5977 16.1593V11.9926C11.5977 11.7532 11.6928 11.5236 11.8621 11.3543C12.0314 11.185 12.261 11.0898 12.5004 11.0898C12.7399 11.0898 12.9695 11.185 13.1388 11.3543C13.3081 11.5236 13.4032 11.7532 13.4032 11.9926V16.1593C13.4032 16.3987 13.3081 16.6283 13.1388 16.7976C12.9695 16.967 12.7399 17.0621 12.5004 17.0621Z"
                                          fill="#64748B"
                                        />
                                        <path
                                          d="M12.4655 9.73568C13.0408 9.73568 13.5072 9.26931 13.5072 8.69401C13.5072 8.11871 13.0408 7.65234 12.4655 7.65234C11.8902 7.65234 11.4238 8.11871 11.4238 8.69401C11.4238 9.26931 11.8902 9.73568 12.4655 9.73568Z"
                                          fill="#64748B"
                                        />
                                      </svg>
                  {errorRes?.error}</p>
                  <button className="dashboard-btn" onClick={() => columnClick(index, lang[0]?.sourceLanguage?.display)}>Try Again</button>
                </div>}
                    <ReactTooltip
                        className="tooltip"
                        place="bottom"
                        id={`source${index}`}
                        role="tooltip"
                    >
                    </ReactTooltip>

                  </div>
                  
                  }
                {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus?.display === lang[0]?.sourceLanguage?.display ? "" :
                  <div
                    className={active ? "circle active" : "circle"}
                    role="button"
                    aria-expanded={active? "true" : "false"}
                    aria-label="More options"
                    tabIndex="0"
                    onClick={() => openInformationDialog(index, lang[0]?.sourceLanguage?.display, lang[0]?.sourceLanguage?.code, "source")}
                    onKeyDown={(e) => keydownOpenInformationDialog(e, index, lang[0], "source")}
                  >
                    <div
                      className="dots"
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div
                      className="blankbg"></div>
                    {popStatus.seq === index && popStatus.status && popStatus.display === lang[0]?.sourceLanguage?.display ?
                      <div className={active ? "popover-body show" : "popover-body"}
                      onKeyDown={(e) => keydownshowModel(e)}
                      >
                        <div className="inner-popover">
                          <button className="DeleteTuvDataBtn" onClick={() => deleteGlossary(index, lang[0]?.sourceLanguage)} onKeyDown={(e) => keydownDeleteGlossary(e, index, lang[0])} aria-label="Delete">Delete</button>
                          <button onClick={() => columnClick(index, lang[0]?.sourceLanguage?.display)} onKeyDown={(e) => keyDownColumnClick(e, index, lang[0])} aria-label="Edit">Edit</button>
                          <button
                            aria-label="Details"
                            onClick={() => showModel(index)}
                            onKeyDown={(e) => keydownDetails(e, index)}
                          >
                            Details
                          </button>
                          <button
                            aria-label="Search in Tm"
                            onClick={() => searchInTm(translationText,lang[0]?.sourceLanguage?.code,depId)}
                            onKeyDown={(e) => keydownSearchInTm(e, translationText, lang, depId)}
                          >
                            Search in TM
                          </button>
                        </div>
                      </div>
                      : ""}
                  </div>}
              </>
            ),
          },
          {
            id: "Part_of_Speech",
            name: "Part of Speech	",
            selector: (row, index) => (
              <>
                {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus?.display === "Part_of_Speech" ? <div className="flex justify-center tableTextarea">
                  <div className="w-d100 mar-bot14 global-dropdown-block">
                    <Select
                     id="part_of_speech_input"
                     menuShouldScrollIntoView={false}
                     closeMenuOnSelect={true}
                     classNamePrefix='cw'
                     aria-label="Part of Speech"
                     className="global-dropdown-select w-d100"
                     onChange={e => setTranslation(e)} options={partOfSpeechFilterList} 
                     defaultValue={partOfSpeechFilterList.filter(data => data?.label === getColumnData(
                      "speech",
                      lang[0]?.sourceLanguage?.code,
                      index
                    ))} />
                  </div>
                  <div className="flex btn-gap">
                    <button onClick={() => updateGlossary("speech", index,lang[0]?.sourceLanguage)} className="blue-btn">Save</button>
                    <button onClick={() => {setTableDataStatus({ seq: "", status: false });setErrorRes("")}} className="blue-btn active">Cancel</button>
                  </div>
                </div> :

                  <div onClick={() => columnClick(index, "Part_of_Speech")}><Link tabIndex={getColumnData("speech",lang[0]?.sourceLanguage?.code,index) ? '0' : '-1'} >
                    {getColumnData(
                      "speech",
                      lang[0]?.sourceLanguage?.code,
                      index
                    )}</Link>
                    {errorRes?.index===index && errorRes?.col==="speech" && 
                <div>
                 <p><svg
                                        className="aaa-change-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="25"
                                        viewBox="0 0 25 25"
                                        fill="none"
                                      >
                                        <path
                                          d="M12.5003 4.16602C10.8522 4.16602 9.24099 4.65476 7.87058 5.57044C6.50017 6.48611 5.43206 7.7876 4.80133 9.31032C4.1706 10.833 4.00558 12.5086 4.32712 14.1251C4.64866 15.7416 5.44234 17.2265 6.60777 18.3919C7.77321 19.5573 9.25807 20.351 10.8746 20.6726C12.4911 20.9941 14.1666 20.8291 15.6894 20.1983C17.2121 19.5676 18.5136 18.4995 19.4292 17.1291C20.3449 15.7587 20.8337 14.1475 20.8337 12.4993C20.8337 10.2892 19.9557 8.1696 18.3929 6.60679C16.8301 5.04399 14.7105 4.16602 12.5003 4.16602ZM12.5003 19.4438C11.1268 19.4438 9.78421 19.0365 8.6422 18.2734C7.50019 17.5104 6.61011 16.4258 6.0845 15.1569C5.55889 13.8879 5.42137 12.4916 5.68932 11.1446C5.95727 9.79747 6.61867 8.56008 7.58987 7.58889C8.56106 6.61769 9.79845 5.95629 11.1455 5.68834C12.4926 5.42039 13.8889 5.55791 15.1579 6.08352C16.4268 6.60913 17.5114 7.49921 18.2744 8.64122C19.0375 9.78323 19.4448 11.1259 19.4448 12.4993C19.4448 13.4113 19.2652 14.3143 18.9162 15.1569C18.5672 15.9994 18.0556 16.765 17.4108 17.4098C16.7659 18.0547 16.0004 18.5662 15.1579 18.9152C14.3153 19.2642 13.4123 19.4438 12.5003 19.4438Z"
                                          fill="#64748B"
                                        />
                                        <path
                                          d="M12.5004 17.0621C12.261 17.0621 12.0314 16.967 11.8621 16.7976C11.6928 16.6283 11.5977 16.3987 11.5977 16.1593V11.9926C11.5977 11.7532 11.6928 11.5236 11.8621 11.3543C12.0314 11.185 12.261 11.0898 12.5004 11.0898C12.7399 11.0898 12.9695 11.185 13.1388 11.3543C13.3081 11.5236 13.4032 11.7532 13.4032 11.9926V16.1593C13.4032 16.3987 13.3081 16.6283 13.1388 16.7976C12.9695 16.967 12.7399 17.0621 12.5004 17.0621Z"
                                          fill="#64748B"
                                        />
                                        <path
                                          d="M12.4655 9.73568C13.0408 9.73568 13.5072 9.26931 13.5072 8.69401C13.5072 8.11871 13.0408 7.65234 12.4655 7.65234C11.8902 7.65234 11.4238 8.11871 11.4238 8.69401C11.4238 9.26931 11.8902 9.73568 12.4655 9.73568Z"
                                          fill="#64748B"
                                        />
                                      </svg>
                  {errorRes?.error}</p>
                  <button type="button" className="dashboard-btn" onClick={() => {columnClick(index, lang[0]?.sourceLanguage?.display);setTranslation({label:getColumnData(
                      "speech",
                      lang[0]?.sourceLanguage?.code,
                      index
                    ),value:partOfSpeech?.findIndex(data => data?.label ===getColumnData(
                      "speech",
                      lang[0]?.sourceLanguage?.code,
                      index
                    ))[0]}) }}>Try Again</button>
                </div>}
                  </div>}
                {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus?.display === "Part_of_Speech" ? "" :

                  <div
                    className={active ? "circle active" : "circle"}
                    onClick={() => openInformationDialog(index, "Part_of_Speech")}
                    onKeyDown={(e) => keydownOpenInformationDialog(e, index, lang, "Part_of_Speech")}
                    role="button"
                    aria-expanded={active? "true" : "false"}
                    aria-label="More options"
                    tabIndex="0"
                  >
                    <div  className="dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="blankbg"></div>
                    {popStatus.seq === index && popStatus.status && popStatus.display === "Part_of_Speech" ?
                      <div className="popover-body"
                      onKeyDown={(e) => keydownshowModel(e)}
                      >
                        <div className="inner-popover">
                          <button onClick={() => columnClick(index, "Part_of_Speech")} onKeyDown={(e) => partSpeechcolumnClick(e, index, "Part_of_Speech")} aria-label="Edit">Edit</button>
                          <button
                            aria-label="Details"
                            onClick={() => showModel(index)}
                            onKeyDown={(e) => keydownDetails(e, index)}
                          >
                            Details
                          </button>
                        </div>
                      </div> : ""}
                  </div>}
              </>
            ),
          },
          {
            name: "Notes & Definition	",
            id: "Notes & Definition",
            selector: (row, index) => (
              <>
                {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus?.display === "notes" ? <div className="flex justify-center tableTextarea">
                  <div className="w-d100 mar-bot14">

                    <textarea  maxLength={1000} onChange={(e) => setTranslationNote(e.target.value)}  className="textarea" defaultValue={translationNote} />
													<small>{isNaN(1000 - translationNote?.length ) ? (1000 -    translationNote?.length) : 1000 - translationNote?.length} characters left</small>
                  </div>
                  <div className="flex btn-gap">
                    <button onClick={() => updateGlossary("notes", index)} className="blue-btn">Save</button>
                    <button onClick={() => {setTableDataStatus({ seq: "", status: false });setErrorRes()}} className="blue-btn active">Cancel</button>
                  </div>
                </div> :
                  <div className="refrence-cell"
                  onClick={() => setNewSourceTermStatus(index, lang[0]?.sourceLanguage?.code, lang[0]?.sourceLanguage?.display,'notes')}

                  >{getColumnData(
                    "notes",
                    lang[0]?.sourceLanguage?.code,
                    index
                  )?<div className="refrence-cell" onClick={() => columnClick(index, "notes")}><Link onClick={() => columnClick(index, "notes")} tabIndex={getColumnData("notes",lang[0]?.sourceLanguage?.code,index) ? '0' : '-1'}>
                    {getColumnData(
                      "notes",
                      lang[0]?.sourceLanguage?.code,
                      index
                    )}</Link></div>:Constants.BLANK}
              {errorRes?.index===index && errorRes?.col==="notes" && 
                <div>
                 <p><svg
                                        className="aaa-change-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="25"
                                        viewBox="0 0 25 25"
                                        fill="none"
                                      >
                                        <path
                                          d="M12.5003 4.16602C10.8522 4.16602 9.24099 4.65476 7.87058 5.57044C6.50017 6.48611 5.43206 7.7876 4.80133 9.31032C4.1706 10.833 4.00558 12.5086 4.32712 14.1251C4.64866 15.7416 5.44234 17.2265 6.60777 18.3919C7.77321 19.5573 9.25807 20.351 10.8746 20.6726C12.4911 20.9941 14.1666 20.8291 15.6894 20.1983C17.2121 19.5676 18.5136 18.4995 19.4292 17.1291C20.3449 15.7587 20.8337 14.1475 20.8337 12.4993C20.8337 10.2892 19.9557 8.1696 18.3929 6.60679C16.8301 5.04399 14.7105 4.16602 12.5003 4.16602ZM12.5003 19.4438C11.1268 19.4438 9.78421 19.0365 8.6422 18.2734C7.50019 17.5104 6.61011 16.4258 6.0845 15.1569C5.55889 13.8879 5.42137 12.4916 5.68932 11.1446C5.95727 9.79747 6.61867 8.56008 7.58987 7.58889C8.56106 6.61769 9.79845 5.95629 11.1455 5.68834C12.4926 5.42039 13.8889 5.55791 15.1579 6.08352C16.4268 6.60913 17.5114 7.49921 18.2744 8.64122C19.0375 9.78323 19.4448 11.1259 19.4448 12.4993C19.4448 13.4113 19.2652 14.3143 18.9162 15.1569C18.5672 15.9994 18.0556 16.765 17.4108 17.4098C16.7659 18.0547 16.0004 18.5662 15.1579 18.9152C14.3153 19.2642 13.4123 19.4438 12.5003 19.4438Z"
                                          fill="#64748B"
                                        />
                                        <path
                                          d="M12.5004 17.0621C12.261 17.0621 12.0314 16.967 11.8621 16.7976C11.6928 16.6283 11.5977 16.3987 11.5977 16.1593V11.9926C11.5977 11.7532 11.6928 11.5236 11.8621 11.3543C12.0314 11.185 12.261 11.0898 12.5004 11.0898C12.7399 11.0898 12.9695 11.185 13.1388 11.3543C13.3081 11.5236 13.4032 11.7532 13.4032 11.9926V16.1593C13.4032 16.3987 13.3081 16.6283 13.1388 16.7976C12.9695 16.967 12.7399 17.0621 12.5004 17.0621Z"
                                          fill="#64748B"
                                        />
                                        <path
                                          d="M12.4655 9.73568C13.0408 9.73568 13.5072 9.26931 13.5072 8.69401C13.5072 8.11871 13.0408 7.65234 12.4655 7.65234C11.8902 7.65234 11.4238 8.11871 11.4238 8.69401C11.4238 9.26931 11.8902 9.73568 12.4655 9.73568Z"
                                          fill="#64748B"
                                        />
                                      </svg>
                  {errorRes?.error}</p>
                  <button className="dashboard-btn" onClick={() => columnClick(index, lang[0]?.sourceLanguage?.display)}>Try Again</button>
                </div>}
                    
                  </div>}
                {tableDataStatus?.seq === index && tableDataStatus?.status && tableDataStatus?.display === "notes" ? "" :
                  <div
                    className={active ? "circle active" : "circle"}
                    onClick={() => openInformationDialog(index, "notes",lang[0]?.sourceLanguage?.code,'notes')}
                    onKeyDown={(e) => keydownOpenInformationDialog(e, index, lang[0], "notes")}
                    role="button"
                    aria-expanded={active? "true" : "false"}
                    aria-label="More options"
                    tabIndex="0"
                  >
                    <div className="dots" onClick={() => columnClick(index, "notes")} >
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="blankbg"></div>
                    {popStatus.seq === index && popStatus.status && popStatus.display === "notes" ?
                      <div className="popover-body"
                      onKeyDown={(e) => keydownshowModel(e)}
                      >
                        <div className="inner-popover">
                          {translationNote?.length > 0 ?
                          <button onClick={()=>deleteGlossary(index, lang[0]?.sourceLanguage)} onKeyDown={(e) => keydownDeleteGlossary(e, index, lang[0])} aria-label="Delete">Delete</button>:Constants.bL}
                          <button onClick={() => columnClick(index, "notes")} onKeyDown={(e) => partSpeechcolumnClick(e, index, "notes")} aria-label="Edit">Edit</button>
                          <button
                            aria-label="Details"
                            onClick={() => showModel(index)}
                            onKeyDown={(e) => keydownDetails(e, index)}
                          >
                            Details
                          </button>
                        </div>
                      </div> : ""}
                  </div>}
              </>
            ),
          },
        ],
        ...col,
      ]);
    }
  }, [browseGlossaryData,errorRes,tableDataStatus, active, translationText,translationNote,partOfSpeechTranslation,languageTranslationText]);


  const getColumnData = (rowName, col, index) => {
    let source="";
    let terms = browseGlossaryData[index];
    if(rowName==='notes'){
      return terms?.notes;
    }
    else{
      terms?.langTerms?.forEach((data) => {
        if (data?.language === col) {
          if (rowName === "source" || rowName === "lang") {
            source = data?.text;
          } else if (rowName === "speech") {
            source = partOfSpeechDisplay[data?.partOfSpeech];  
          }
        }
      });
      return source
    }

  };

  const keydownSearchInTm=(event, translationText, lang, depId)=>{
    if (event.key === Constants.ENTER) {
      searchInTm(translationText,lang[0]?.sourceLanguage?.code,depId);
    }
  }
  const searchInTm=(text,srcLang,departmentId)=>{
      navigate(`/one-tm?containingText=${text}&srcLang=${srcLang}&depId=${departmentId}&md=${180}`)
  }
  const keydownSearchInTmTargetLanguage = (event, translationText, lang, depId, res) => {
    if (event.key === Constants.ENTER) {
      searchInTmTargetLanguage(translationText,lang[0]?.sourceLanguage?.code,depId,res?.code);
    }
  }

  const searchInTmTargetLanguage=(text,srcLang,departmentId,trg)=>{
    navigate(`/one-tm?containingText=${text}&srcLang=${srcLang}&trg=${trg}&depId=${departmentId}&md=${180}`)
}


  const departmentData = () => {
    let departmementsData = [];
    if (
      department &&
      department?.length > 0 &&
      glossaryDep &&
      glossaryDep?.length > 0
    ) {
      department?.forEach((dep) => {
        glossaryDep?.forEach((tmDep) => {
          if (dep?.id === tmDep?.userGroup?.id) {
            departmementsData?.push(tmDep);
          }
        });
        if (!departmementsData?.find((el) => el?.userGroup?.id === dep?.id)) {
          departmementsData?.push({ userGroup: dep });
        }
      });
      setDepGroup(departmementsData);

    } else {
      if (department && department?.length > 0) {
        department?.forEach((dep) => {
          departmementsData?.push({ userGroup: dep });
        });
      }
    }
    setDepGroup(departmementsData);
    showGlobalOverlay(false)
  };


  const getCustomer = () => {
    getAxiosResponse(APIUrls.GET_CUSTOMER_INFORMATION)
      .then((res) => {
        if (res?.data?.data) {
          setCustomer(res?.data?.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };


  const tmCreatedDate = (glossary) => {
    return dateUtil.format(glossary?.lastModifiedDate);
  };

  const userGroupData = (glossary) => {
    return glossary?.lastModifiedUser?.firstName + " " + glossary?.lastModifiedUser?.lastName;
  };

  const setSection = (dep, forStatus) => {
    setActiveSection("searchedit");
    if (forStatus) {
      setSelectedTag([transaltionType[4]?.value])
      setValueForMultiSelect([transaltionType[4]])
    }else{
      setValueForMultiSelect([])
      setSize(15)
      updateCurrentPage(1) 
    }
    if (dep) {
      setDepId(dep);
      getBrowseGlossaryForRedirect(dep, forStatus)
    }
    setSourceErrorMessage("")
    setSelectedLanguage([])
    setErrorRes({error:"",index:"",col:""})
    $('#search-edit-btn').trigger('focus');
  };

  const defaultManageTab=(dep)=>{
    setActiveSection("searchedit");
    setDepId(dep)
    setSelectedTag([])
    setBrowseGlossary([])
    setPageCount(0)
    getBrowseGlossaryForRedirect(dep,null)
    setValueForMultiSelect([]) 
    setErrorRes({error:"",index:"",col:""})
    setSelectedLanguage([])
    setSourceErrorMessage("")
  }


  const setTranslation = (e) => {
    setPartOfSpeechTranslation(e);
  }


  const userGroupName = (glossary) => {
    if (glossary.status === "PROCESSED") {
      return glossary.userGroup.name + " " + "Department";
    } else {
      return glossary.userGroup.name;
    }
  };

  const download = (url, id, display) => {
    const dep = department.filter(data => data.id === id)[0]
    var digits = '0123456789';
    let token = '';
    for (let i = 0; i < 3; i++) {
      token += digits[Math.floor(Math.random() * 10)];
    }
    let dtkn = `&dtkn=${token}`
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    const formattedToday = `${yyyy}-${mm}-${dd}`;
    const organizationName = accountPermission?.organization?.name.toLowerCase().replaceAll(" ", "_");
    const userLocale = accountPermission?.user?.locale.toLowerCase();

    let fileName = "";
    if (display === "company") {
      fileName = `${organizationName}_general_${formattedToday}_${userLocale}.zip`;
    } else {
      const departmentName = dep?.name;
      fileName = `${organizationName}_${departmentName}_${formattedToday}_${userLocale}.zip`;
    }

    showGlobalOverlay(true);
    downloadFile(APIUrls.REFERENCE_DOWNLOAD_URL(id) , fileName)
      .then((res) => {
        showGlobalOverlay(false);
      })
      .catch((err) => {
        showGlobalOverlay(false);
        handleError(err);
      });
  };


  const downloadStyleGuideFile=(url,fileName)=>{
    showGlobalOverlay(true);
    downloadFile(APIUrls.STYLE_GUIDE_FILE_DOWNLOAD(url) , fileName)
      .then((res) => {
        showGlobalOverlay(false);
      })
      .catch((err) => {
        showGlobalOverlay(false);
        handleError(err);
      });
  }


  const deleteGlossaryGeneral = (departmentId) => {
    $(document.activeElement).addClass('delFocus');
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"deleteGlossary"
        });
        $("h1").attr({
        'id': 'deleteGlossary',
       });
      }, 200);
      setTimeout(() => {
        $('#yes-delete-glossary').trigger('focus');
      }, 500);
      confirmAlert({
        title: `${translate("ref.delete_glossary_title")}`,
        message: <p>{`${translate("ref.delete_glossary_description")}`}</p>,
        buttons: [
          {
          label: `${t('button_yes')}`,
          id: 'yes-delete-glossary',
          onClick: () => deleteGlossaryGeneralAfterConfirm(departmentId),
          onKeyDown : (e) => {
            if(e.key === Constants.TAB){
              if(e.shiftKey === true){
              e.preventDefault()
              $('#no-delete-glossary').trigger('focus');
              }
            }
            }
          },
          {
          label: `${t('button_no')}`,
          id: 'no-delete-glossary',
          onKeyDown : (e) => {
            if(e.key === Constants.TAB){
              if(e.shiftKey === false){
              e.preventDefault()
              $('#yes-delete-glossary').trigger('focus');
              }
            }
            }
          }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        overlayClassName: "delete_overlay",
        afterClose: () => {
          $('.delFocus').trigger("focus");
          $('.delFocus').removeClass("delFocus");
        }
      });		
    


  }

  const keydowndeleteTargetLanguageData = (event, row, res) => {
    if (event.key === Constants.ENTER) {
      deleteTargetLanguageData(row,res?.code,res);
    }
  }
  const deleteTargetLanguageData = (row,code,res) => {
    let targetLanguages=row?.langTerms?.filter(data=>data.language===code)[0]

    setTimeout(() => {
      $('#yes-delete-glossary').trigger('focus');
    }, 500);
    confirmAlert({
      title: `${translate("Delete Term Translation From Your Glossary")}`,
      message: <p>{"This action is not reversible. Are you sure?"}<br/>
      {`Click Yes to delete ${targetLanguages.text} from your Glossary, or No to cancel.`}
      </p>,
      buttons: [
        {
        label: `${t('button_yes')}`,
        id: 'yes-delete-glossary',
        onClick: () => deleteTranslateLanguage(row,code,res),
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === true){
            e.preventDefault()
            $('#no-delete-glossary').trigger('focus');
            }
          }
          }
        },
        {
        label: `${t('button_no')}`,
        id: 'no-delete-glossary',
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === false){
            e.preventDefault()
            $('#yes-delete-glossary').trigger('focus');
            }
          }
          }
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay"
    });		
  


}


  const deleteStyleGuideFiles = () => {
    $(document.activeElement).addClass('delFocus');
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"deleteStyleGuide"
        });
        $("h1").attr({
        'id': 'deleteStyleGuide',
       });
      }, 200);
    setTimeout(() => {
      $('#yes-delete-glossary').trigger('focus');
    }, 500);
    confirmAlert({
      title: `${translate("Delete style guide")}`,
      message: <p>{`${translate("Click accept to delete the style guide. This cannot be undone.")}`}</p>,
      buttons: [
        {
        label: `${t('button_yes')}`,
        id: 'yes-delete-glossary',
        onClick: () => deleteAllStyleGuide(),
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === true){
            e.preventDefault()
            $('#no-delete-glossary').trigger('focus');
            }
          }
          }
        },
        {
        label: `${t('button_no')}`,
        id: 'no-delete-glossary',
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === false){
            e.preventDefault()
            $('#yes-delete-glossary').trigger('focus');
            }
          }
          }
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
      afterClose: () => {
        $('.delFocus').trigger("focus");
        $('.delFocus').removeClass("delFocus");
      }
    });		
  


}

const deleteAllStyleGuide = () =>{
  showGlobalOverlay(true);
  deleteAxiosResponse(APIUrls.DELETE_STYLE_GUIDE).then((res) => {
    showGlobalOverlay(false);
    getStyleGuide()
  })
    .catch((err) => {
      showGlobalOverlay(false);
      handleError(err);
    });
}

  const deleteGlossaryGeneralAfterConfirm = (departmentId) =>{
    showGlobalOverlay(true);
    deleteAxiosResponse(APIUrls.DELETE_GLOSSARY_DEPARTMENT(departmentId)).then((res) => {
      setSuccessMessage(Constants.GLOSSARY_DELETE_MESSAGE)
      glossaryDepartment();
      getGlossary()
      showGlobalOverlay(false);
    })
      .catch((err) => {
        showGlobalOverlay(false);
        handleError(err);
      });
  }

  const handlePageChange = (paging) => {
    updateCurrentPage(paging)
    getBrowseGlossary(paging, size)
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };

  const handlePerRowsChange =  (newPerPage, page) => {
     setSize(newPerPage)
     updateCurrentPage(page)
  }

  useEffect(()=>{
   if(size !==undefined && size !==""){
     getBrowseGlossary(currentPage, size)
   }
  },[size])



  const dispatch = useDispatch();
  const sourceFiles = useSelector(
    (reduxStore) => reduxStore.source_files
  ).value;

  function fileSelection(e) {
    if (e?.target) {
      setSelectedFile(e?.target?.files[0]);
      setFileUploadResponse("");
      setUploadStatus("")
      const file=e?.target?.files[0];
      if(checkFileSizeInGb(file,accountPermission?.maxFileUploadSizeGb)){
        setFileUploadPermission(true)
      }else{
        setFileUploadPermission(false)
      }
    }
  }

  const clearValue = (e) => {
    e.target.value = null;
  };



  function handleFileSelect(e) {
    if (files.length === 0) {
      if(styleGuideName !==""){
        let obj={
          "name": "STYLE_GUIDE",
 "docType": "STYLE_GUIDE",
 "referenceDocument.docType": "STYLE_GUIDE",
 "referenceDocument.name":"StyleGuide"
          // document.id:
        }

        if(styleGuide !==""){
          obj={
            "name": "STYLE_GUIDE",
   "docType": "STYLE_GUIDE",
   "referenceDocument.docType": "STYLE_GUIDE",
   "referenceDocument.name":"StyleGuide",
     "document.id":styleGuide.id,
     "referenceDocument.id":styleGuide.id,
          }
        }

        postAxiosFormDataResponse(APIUrls.STYLE_GUIDE_UPLOAD, obj).then((res) => {
          setUploadStatus("")
          setDocumentVariant(res?.data?.documentFileId);
          setFiles((files) => [...files, selectedfile]);
          setCurrentFileIndex(0);
          setSelectedFile("");
          setLasChunkStatus(true)
          dispatch(
            updateSourceFiles([
              ...sourceFiles,
              selectedfile.name.replaceAll(" ", "_"),
            ])
          );
        });
      }else{
      postAxiosFormDataResponse(APIUrls.GLOSSARY_UPLOAD, {
        name: "GLOSSARY_UPLOAD",
        docType: "GLOSSARY_UPLOAD",
        "referenceDocument.docType": "GLOSSARY_UPLOAD",
        "referenceDocument.name": "Glossary",
        // document.id:
      }).then((res) => {
        setUploadStatus("")

        setDocumentVariant(res?.data?.documentFileId);
        setFiles((files) => [...files, selectedfile]);
        setCurrentFileIndex(0);
        setSelectedFile("");
        setLasChunkStatus(true)
        dispatch(
          updateSourceFiles([
            ...sourceFiles,
            selectedfile.name.replaceAll(" ", "_"),
          ])
        );
      });
    }
    } else {
      fileQueue.current.push(selectedfile);
      updateSourceFiles([
        ...sourceFiles,
        selectedfile.name.replaceAll(" ", "_"),
      ]);
    }
    setFileUploadStatus(true)
  }
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 4;



  const TagMenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
        color: aaaSelected ? "white" : "#1C233C",
        background: aaaSelected ? "black" : "#FFF",
        fontSize: "85.71429%",
        //autoFocus: true,
      },
    },
  };


  function readAndUploadCurrentChunk() {
    const reader = new FileReader();
    const file = files[currentFileIndex];
    if (!file) {
      return;
    }
    const from = currentChunkIndex * chunkSize;
    const to = from + chunkSize;
    const blob = file.slice(from, to);
    reader.onload = (e) => uploadChunk(e);
    reader.readAsDataURL(blob);
  }

  function uploadChunk(readerEvent) {
    const file = files[currentFileIndex];
    const data = readerEvent.target.result;
    setFileUploadResponse("");
    const params = new URLSearchParams();
    params.set("name", file.name);
    params.set("size", file.size);
    params.set("docFileId", documentVariant);
    params.set("ignoreValidations", false);
    params.set("currentChunkIndex", currentChunkIndex);
    params.set("totalChunks", Math.ceil(file.size / chunkSize));
    $('.progressReport').trigger('focus');
    if (fileDepartmentId !== null) {
      params.set("departmentId", fileDepartmentId);
    }
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    const url =
      `${process.env.REACT_APP_BACKEND_SERVER}${ styleGuideName !==""?APIUrls.STYLE_GUIDE_UPLOAD_FILE :APIUrls.GLOSSARY_HTM}?` +
      params.toString();
    postAxiosResponse(url, data, { headers }). then((response) => {
      const file = files[currentFileIndex];
      const filesize = files[currentFileIndex].size;
      const chunks = Math.ceil(filesize / chunkSize) - 1;
      const isLastChunk = currentChunkIndex === chunks;
      if (isLastChunk) {
        file.finalFilename = response.data.finalFilename;
        setLasChunkStatus(false)
        setFileUploadStatus(false)
        if(response.data.code === 'ERR_BAD_REQUEST' || response.data.code === 'ERR_BAD_RESPONSE'){
          setFileUploadResponse(Constants.CONNECTION_FAILED);
        }else{
          setFileUploadResponse(response?.data?.detail);
          getGlossary()
          setTimeout(() => {
            $('#files').trigger('focus');
          }, 300);
        }
        if (response?.data?.detail === "") {
          setUploadStatus("Upload Successful")
          setTimeout(() => {
            $('#hideUploadModal').trigger("focus");
          }, 300);
        }

        setCurrentChunkIndex(null);
        setFiles(files.filter((fileInfo) => fileInfo.name !== file.name));
        setCurrentFileIndex(null);
      } else {
        setCurrentChunkIndex(currentChunkIndex + 1);
      }
    });
  }

  const getBrowseGlossary = (pageNumber, pageSize) => {
    showGlobalOverlay(true)
    let start = (`&start=${pageSize * (+pageNumber - 1)}`) + `&size=${pageSize}`;
    let url = urlData + start;
    getAxiosResponse(APIUrls.GLOSSARY_BROWSE + (url))
      .then((res) => {
        showGlobalOverlay(false)
        if (res.data?.data) {
          if ($('#search-btn').is(':focus')) {
            $('#search-btn').attr("aria-labelledby", "searchResults");
          } else if ($('#AdditionalFilter').is(':focus')) {
            $('#AdditionalFilter').attr("aria-labelledby", "searchResults");
          }
          setBrowseGlossary(res.data?.data?.body?.glossary?.terms);
          setPageCount(res.data?.data?.body?.stats?.count);
          setTermLanguagesColumns(res.data?.data?.body?.stats?.termLanguageFound)
          setTimeout(() => {
            if (paginationRef.current) {
                $('#'+ paginationRef.current).trigger('focus');
                paginationRef.current = '';
            }
          }, 300);
        }
      })
      .catch((err) => {
        showGlobalOverlay(false)
        handleError(err);
      });
  };

  const getBrowseGlossaryForRedirect = (dep, forStatus) => {
    let url = dep ? `depId=${dep}&size=${size}` : "";
    url = forStatus !== null && forStatus !== undefined ? url + `&ht=${forStatus}` : url;
    showGlobalOverlay(true)
    getAxiosResponse(APIUrls.GLOSSARY_BROWSE + (url))
      .then((res) => {
        showGlobalOverlay(false)
        if (res.data?.data) {
          setBrowseGlossary(res.data?.data?.body?.glossary?.terms);
          setPageCount(res.data?.data?.body?.stats?.count);
        }
      })
      .catch((err) => {
        showGlobalOverlay(false)
        handleError(err);
      });
  };

  const handleRowSelected = (data) => {
    $(document.activeElement).addClass('boxChecked');
    const ids = data?.selectedRows.map((data) => data?.id);
    selectedSourceTerms(ids);
    setToggleCleared(false)
  };

  const setLanguages = (index) => {
    let terms = browseGlossaryData[index];
    setDetails(terms);
    let obj = [];
    const lang = glossaryLanguage.filter(
      (data) => data?.userGroup?.id === depId
    );
    lang[0]?.termLanguage.forEach((data) => {
      terms.langTerms.forEach((lang) => {
        if (lang.language === data.code) {
          obj.push({ language: data?.display, text: lang.text,displayName:data?.displayName });
        } else {
          let finalData = obj.filter(
            (objFilter) => objFilter?.language === data?.display
          );
          if (finalData.length === 0) {
            obj.push({ language: data?.display, text: "(no translation)",displayName:data?.displayName  });
          }
        }
      });
    });
    setTermLanguages(obj);
  };

  const addNewTerm = () => {
    setStatus(!status);
  };

  const isDisabled=()=>{
    return selectSourceTerms?.length ===0
  }

  const newSourceTerm = () => {
    if (sourceTerm !== null && sourceTerm.trim()!=='') {
      let obj = {
        groupId: depId,
        notes: notes === null ? null : notes,
        partOfSpeech: partOfspeech?.value ? partOfspeech?.value : "NONE",
        sourceTermStatus: statusSourceTerm?.updateValue
          ? statusSourceTerm?.updateValue
          : null,
        text: sourceTerm,
      };
      showGlobalOverlay(true)
      postAxiosResponse(APIUrls.CREATE_UPDATE_GLOSSARY, obj)
        .then((res) => {
          let errors=res?.data?.errors?.source
          if(errors){
          setSourceErrorMessage(Constants.PART_OF_SPEECH_ERROR_MSG)
          }else{
            getBrowseGlossary(1, size)
            cancelSourceTerm();
           setSourceErrorMessage("")
          }
          showGlobalOverlay(false)
          setTableDataStatus({ seq: "", status: false })
        })
        .catch((err) => {
          showGlobalOverlay(false)
          handleError(err);
        });
        $('.addNew-term button').trigger('focus');
    } else if (sourceTerm === null) {
      $('#addSourceTerm').trigger('focus');
    }
  };

  const bulkDelteGlossary = () => {
    $(document.activeElement).addClass('delFocus');
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"bulkDelteGlossary"
        });
        $("h1").attr({
        'id': 'bulkDelteGlossary',
       });
      }, 200);
    setTimeout(() => {
      $('#yes-delete-termm-glossary').trigger('focus');
    }, 500);
    confirmAlert({
      title: `${translate("ref.delete_glossary_bulk_term_title")}`,
      message: <p>{`${translate("ref.delete_glossary_term_description")}`}</p>,
      buttons: [
        {
        label: `${t('button_yes')}`,
        id: 'yes-delete-termm-glossary',
        onClick: () => bulkDelteGlossaryAfterConfirm(),
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === true){
            e.preventDefault()
            $('#no-delete-term-glossary').trigger('focus');
            }
          }
          }
        },
        {
        label: `${t('button_no')}`,
        id: 'no-delete-term-glossary',
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === false){
            e.preventDefault()
            $('#yes-delete-termm-glossary').trigger('focus');
            }
          }
          }
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
      afterClose: () => {
        if ($(document.activeElement).hasClass('lastdisable')) {
          return;
        } else {
          $('.delFocus').trigger("focus");
          $('.delFocus').removeClass("delFocus");
        }
      }
    });		
  };

  const bulkDelteGlossaryAfterConfirm = () =>{
    $('.lastdisable').trigger('focus');
    showLoader(true);
    let obj = { delete: true, groupId: depId, id: selectSourceTerms };
    putAxiosResponse(APIUrls.BULK_UPDATE_GLOSSARY, obj)
      .then((res) => {
        getBrowseGlossary(currentPage, size)
        selectedSourceTerms([])
        setToggleCleared(true)
        showLoader(false);
      })
      .catch((err) => { });
  }
  const bulkUpdateGlossaryStatus = (data) => {
    setUpdatedStatus(data)
    showLoader(true);
    let obj = { newStatus: data?.updateValue, groupId: depId, id: selectSourceTerms };
    putAxiosResponse(APIUrls.BULK_UPDATE_GLOSSARY, obj)
      .then((res) => {
        getBrowseGlossary(currentPage, size)
        selectedSourceTerms([])
         setUpdatedStatus(null)
        showLoader(false);
        $(".boxChecked").trigger('focus');
        $(".boxChecked").removeClass('boxChecked');
          setToggleCleared(true)
      })
      .catch((err) => { });
  };

  const cancelSourceTerm = () => {
    setStatus(false);
    setSourceTerm(null);
    setPartOfspeech(null);
    setNotes(null);
    setSourceErrorMessage("")
    setStatusSourceTerm(null);
    $('.addNew-term button').trigger('focus');
  };

  const partOfSpeech = [
    { label: "adjective", value: "ADJECTIVE" },
    { label: "adverb", value: "ADVERB" },
    { label: "noun", value: "NOUN" },
    { label: "phrase", value: "PHRASE" },
    { label: "proper noun", value: "PROPER_NOUN" },
    { label: "verb", value: "VERB" },
    { label: "other", value: "OTHER" },
  ];

  const partOfSpeechDisplay = {
    'ADJECTIVE':'adjective',
    'ADVERB':'adverb',
    'NOUN':'noun',
    'PHRASE':'phrase',
    'PROPER_NOUN':'proper noun',
    'VERB':'verb',
    'OTHER':'other',
    'NONE':'none'
  }



  const ModifiedWithin = [
    { label: "Last 60 days", value: "60" },
    { label: "Last 180 days", value: "180" },
    { label: "This year", value: "-2" },
    { label: "This year and last year", value: "-3" },
    { label: "Since beginning", value: "-1" },
  ]

  const Status = [
    { label: "Approved", value: "APPROVED", updateValue: "approved" },
    { label: "Needs Review", value: "NEEDS_REVIEW", updateValue: "needs review" },
    { label: "Rejected", value: "REJECTED", updateValue: "rejected" },
  ];



  const iconComponent = () => {
    return (
      <i className="arrow-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.21967 0.815454C0.512563 0.519849 0.987437 0.519849 1.28033 0.815454L6 5.57882L10.7197 0.815454C11.0126 0.519849 11.4874 0.519849 11.7803 0.815454C12.0732 1.11106 12.0732 1.59033 11.7803 1.88593L6.53033 7.18455C6.23744 7.48015 5.76256 7.48015 5.46967 7.18455L0.21967 1.88593C-0.0732233 1.59033 -0.0732233 1.11106 0.21967 0.815454Z"
            fill="#076FA3"
          ></path>
        </svg>
      </i>
    );
  };

  const handleTranslationChange = (value) => {
    var values = []
    setValueForMultiSelect(value)
    value.forEach((val)=>{
      values.push(val.value)
    })
    setSelectedTag(values);
  };

  const handleLanguageChange = (value) => {
    setSelectedLanguage(value);
  };
   const getStyleGuide=()=>{
    getAxiosResponse(APIUrls.GET_CUSTOMER_STYLE_GUIDE)
      .then((res) => {
        if (res.data !== "") {
          setStyleGuideData(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
   }
  const allGlossarydownload = () => {
    showGlobalOverlay(true)
    var digits = '0123456789';
    let token = '';
    for (let i = 0; i < 3; i++) {
      token += digits[Math.floor(Math.random() * 10)];
    }
    let dtkn = `&dtkn=${token}`

    downloadFile(APIUrls.GLOSSARY_TM_DOWNLOAD + urlData + startPage + dtkn, null).then(res => {
      showGlobalOverlay(false)
    }).catch(err => {
      showGlobalOverlay(false)
      handleError(err)
    })
  }



  const updateGlossary = (code, index, lng) => {
    let terms = browseGlossaryData[index];
    showGlobalOverlay(true)

    if (code === "source") {
      let obj = {}
      terms.langTerms.forEach(data => {
        if (data.language === sourceData?.code) {
          obj = { ...obj, id: terms.id, groupId: depId, language: sourceData?.language, oldText: data?.text, newText: translationText}
        }
      })
      putAxiosResponse(APIUrls.CREATE_UPDATE_GLOSSARY, obj).then(res => {
        showGlobalOverlay(false)
        if(res?.data?.data ==="" ){
          setErrorRes({error:res?.data?.errors?.source,index:index,col:"source"})
          setTableDataStatus({ seq: "", status: false })
          return ;
        }
        terms.langTerms.forEach(data => {
          if (data.language === sourceData?.code) {
            data.text = translationText;
            terms.sourceTerm.text=translationText;
          }
        })
        setTableDataStatus({ seq: "", status: false })
      }).catch(err => {
        showGlobalOverlay(false)
        handleError(err)
      })
    } else if (code === "speech") {
      let obj = { groupId: depId, id: terms.id, partOfSpeech: partOfSpeechTranslation?.value?partOfSpeechTranslation?.value:terms?.sourceTerm?.partOfSpeech }
      putAxiosResponse(APIUrls.CREATE_UPDATE_GLOSSARY, obj).then(res => {
        showGlobalOverlay(false)
        if(res?.data?.data ==="" ){
          setErrorRes({error:res?.data?.errors?.source,index:index,col:"speech"})
          setTableDataStatus({ seq: "", status: false })
          return ;
        }
        terms.langTerms.forEach(data => {
          if (data.language === lng?.code) {
            data.partOfSpeech = partOfSpeechTranslation?.value?partOfSpeechTranslation?.value:terms?.sourceTerm?.partOfSpeech;
            terms.sourceTerm.partOfSpeech=partOfSpeechTranslation?.value?partOfSpeechTranslation?.value:terms?.sourceTerm?.partOfSpeech;
          }
        })
        setTableDataStatus({ seq: "", status: false })
      }).catch(err => {
        showGlobalOverlay(false)
        handleError(err)
      })
    } else if (code === "notes") {
      let obj = { id: terms.id, groupId: depId, oldText: terms?.notes?terms?.notes:"", newText: translationNote }
      putAxiosResponse(APIUrls.CREATE_UPDATE_GLOSSARY, obj).then(res => {
        showGlobalOverlay(false)
        if(res?.data?.data ==="" ){
          setErrorRes({error:res?.data?.errors?.source,index:index,col:"notes"})
        setTableDataStatus({ seq: "", status: false })
          return ;
        }
        terms.notes=translationNote;
        setTableDataStatus({ seq: "", status: false })
      }).catch(err => {
        showGlobalOverlay(false)
        handleError(err)
      })
    } else {
      let data = terms.langTerms.filter(data => data.language === lng.code);
      let obj = {
          id: terms.id,
          groupId: depId,
          language: lng?.display,
          oldText: data.length > 0 ? data[0].text : "",
          newText: languageTranslationText
      };
      putAxiosResponse(APIUrls.CREATE_UPDATE_GLOSSARY, obj).then(res => {
        showGlobalOverlay(false)
        if(res?.data?.data ==="" ){
          setErrorRes({error:res?.data?.errors?.source,index:index,col:""})
          return ;
        }
        terms.langTerms=res?.data.glossary.terms[0].langTerms;
        terms.langTerms.forEach(data => {
          if (data.language === lng.code) {
            data.text = languageTranslationText;
          }
        })
        setTableDataStatus({ seq: "", status: false })
      }).catch(err => {
        showGlobalOverlay(false)
      })
    }
    setErrorRes("")
  }
  const keydownDeleteGlossary = (event, index, lang) => {
    if (event.key === Constants.ENTER) {
      deleteGlossary(index, lang?.sourceLanguage);
    }
  }
  const deleteGlossary = (index, lng) => {
    $(document.activeElement).closest('.inner-popover').addClass('delFocus');
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"deleteGlossaryTerm"
        });
        $("h1").attr({
        'id': 'deleteGlossaryTerm',
       });
      }, 200);
    setTimeout(() => {
      $('#yes-delete-single-term-glossary').trigger('focus');
    }, 500);
    confirmAlert({
      title: `${translate("ref.delete_glossary_term_title")}`,
      message: <p>{`${translate("ref.delete_glossary_term_description")}`}</p>,
      buttons: [
        {
        label: `${t('button_yes')}`,
        id: 'yes-delete-single-term-glossary',
        onClick: () => deleteGlossaryAfterConfirm(index,lng),
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === true){
            e.preventDefault()
            $('#no-delete-single-term-glossary').trigger('focus');
            }
          }
          }
        },
        {
        label: `${t('button_no')}`,
        id: 'no-delete-single-term-glossary',
        onKeyDown : (e) => {
          if(e.key === Constants.TAB){
            if(e.shiftKey === false){
            e.preventDefault()
            $('#yes-delete-single-term-glossary').trigger('focus');
            }
          }
          }
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
      afterClose: () => {
        $('.delFocus').closest('.circle').trigger("focus");
        $('.delFocus').removeClass("delFocus");
      }
    });		

  }

  const deleteGlossaryAfterConfirm = (index, lng) => {
    let terms = browseGlossaryData[index];
    let obj = {}
    terms.langTerms.forEach(data => {
      if (data.language === lng?.code) {
        obj = { ...obj, id: terms.id, groupId: depId, language: lng?.display, oldText: data.text, delete: true }
      }
    })

    putAxiosResponse(APIUrls.CREATE_UPDATE_GLOSSARY, obj).then(res => {
      getBrowseGlossary(1, size)
      $('.lastdisable').trigger('focus');
    }).catch(err => {
    })
  }
  const handleInputChange = (e) => {
    if(e.length > 0) {
      $("#selected-lang-container").addClass("display-none");
    } else {
      $("#selected-lang-container").removeClass("display-none");
    }
  }
  const noDataFoundComponent = () => {
    return (
      <div className="no-data-display align-center">
        <i className="nodata-icon"></i>
        <p>{Constants.NO_DATA_FOUND}</p>
      </div>
    );
  };

  const getEmptyButtonForLayoutMatch = () => {
    return (
      <>

        <button
          className="inline-flex mr-15 display-hidden"
          aria-label="Edit"
        >
          <svg
            className="aaa-change-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="18"
            viewBox="0 0 14 18"
            fill="none"
          >
            <path
              d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z"
              fill="#1D4ED8"
              stroke="white"
              strokeWidth="0.3"
            />
          </svg>
        </button>

        <button

          className="inline-flex mr-15 display-hidden"
          aria-label="Download"
        >
          <svg
            className="aaa-change-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
          >
            <path
              d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z"
              fill="#1D4ED8"
            />
          </svg>
        </button>
        <button type="button"
          className="mr-15 inline-flex display-hidden" aria-label="delete" >
          <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z" fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.3" />
          </svg>
        </button>
      </>
    )
  }

  /// Inline editing functions
  const keydownOpenInformationDialog = (event, index, lang, source) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      event.preventDefault();
      if (source==="lang") {
        openInformationDialog(index, lang?.display, lang?.code, "lang");
      } else if (source==="source") {
        openInformationDialog(index, lang?.sourceLanguage?.display, lang?.sourceLanguage?.code, "source");
      } else if (source==="Part_of_Speech") {
        openInformationDialog(index, "Part_of_Speech");
      } else if (source==="notes") {
        openInformationDialog(index, "notes",lang[0]?.sourceLanguage?.code,'notes');
      }
    } else if (event.key === Constants.ESCAPE && active) {
      event.preventDefault();
      setactive(!active);
      setTimeout(() => {
        $(event.target).closest('.circle').trigger('focus');
        $('.addFocus').removeClass('addFocus');
      }, 100);
    }
  }

  const openInformationDialog = (index, display, code, from) => {
    setactive(!active);
    setPopopStatus({ seq: index, status: true, display: display });
    if (from === 'source') {
      setNewSourceTermStatus(index, code, display,'source')
    }
    if(from === 'notes'){
      setTranslationNote(getColumnData(
        "notes",
        code,
        index
      ))
    }
    if(from === 'lang'){
      setLanguageTranslationText(getColumnData(
        "lang",
        code,
        index
      )?getColumnData(
        "lang",
        code,
        index
      ):""
      )
    }
    setTimeout(() => {
      $(document.activeElement).find('.inner-popover button:first').trigger('focus');
    }, 300);
  };


  const setNewSourceTermStatus = (index, code, language,from) => {
    if(from==='source')
    {
      setSourceData({ index: index, code: code, language: language })
      setTranslationText(getColumnData("source", code, index))
    }
    if(from === 'notes'){
      setTranslationNote(getColumnData(
        "notes",
        code,
        index
      ))
    }
    if(from === 'lang'){
      setLanguageTranslationText(getColumnData(
        "lang",
        code,
        index
      ))
    }

  }


const partSpeechcolumnClick = (event, index, source) => {
  if (event.key === Constants.ENTER) {
    if (source === "Part_of_Speech") {
      columnClick(index, "Part_of_Speech");
    }
    if (source === "notes") {
      columnClick(index, "notes");
    }
  }
}
const keyDownColumnClick = (event, index, lang) => {
  if (event.key === Constants.ENTER) {
    columnClick(index, lang?.sourceLanguage?.display)
  }
}
const diffLangcolumnClick = (event, index, res) => {
  if (event.key === Constants.ENTER) {
    columnClick(index, res.display);
  }
}
  const columnClick = (index, display, event) => {
    event?.stopPropagation()
    setTableDataStatus({ seq: index, status: true, display: display })
    $(document.activeElement).parent().parent().addClass('addFocus');
    const elem = $(document.activeElement).closest('.circle').parent();
    setTimeout(() => {
      elem.addClass('addFocus');
      if ($('#part_of_speech_input').length) {
        $('#part_of_speech_input input').trigger("focus");
      } else {
        $('textarea').trigger("focus");
      }
    }, 300);
  }

  const getColumnCurrentStatus = (index) => {
    let source = 'needs_review_term';
    let terms = browseGlossaryData[index];
    if (terms && terms?.status) {
      if (terms?.status?.code === 'approved') {
        source = 'approved_term'
      }
      else if (terms?.status?.code === 'rejected') {
        source = 'rejected_term'
      }
    }

    return source;
  };
  const crumbs = [
     {label:'Reference', url:''},
  ];


  const setActionManageTab=()=>{
    setActiveSection("manage")
    getAvailableDepartment();
    glossaryDepartment();
    getGlossary()
    getNeedUpdate()
    setTableDataStatus({ seq: "", status: false });
    setErrorRes("")
  }

  const createProjectRefrence=()=>{
    dispatch(updateSourceFiles([]));
  postAxiosResponse(APIUrls.CREATE_PROJECT,{"id":null,"tags":[],"name":"Glossary translation","userGroup":{"id":departments[1]?.value},"assetIds":null,"projectContentType":"CW_GLOSSARY","workspace":null,"projectUpdateGlossary":null,"intendedUse":{"id":intendendUseTaskData[1]?.id},"status":"CONFIGURED_BASIC_PROJECT_INFO","projectFollowers":null})
      .then((res) => {

          const projectId = res.data.data.id;
          let projectResource = transformBlankToNull(res.data.data);
          //deleted  this key as it was giving 400 
          delete projectResource["owner"];
          delete projectResource["projectFollowers"];    
          if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
            delete projectResource["workspace"]['workspaceMembers'];
          }          
          projectResource.name=`Project-${projectId}`;
          projectResource.intendedUse = {"id":projectResource.intendedUse.id};
          projectResource.targetLanguages = []
          putAxiosResponse(APIUrls.PROJECT(projectId), projectResource).then((res)=>{
            dispatch(projectCreationStepFilter("Source Material Step 1"))               
            dispatch(updateSourceLanguage({}));	
            dispatch(updateTargetLanguage([]));	   
            dispatch(departmentSelected(""));
            dispatch(updateProjectFollowers([]));
            dispatch(updateInitializedProjectWorkflows([]));
            dispatch(updateProjectInfoValidation({}));
            dispatch(updateProjectInfoConfiguration({}));
            dispatch(updateProjectInfo({}));
            showGlobalOverlay(false)
            navigate(`/createProject/${projectId}`);
          });
          
      })
      .catch((err) => {
        console.error("Error post request");
      });
  
  }

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>

        {collectionExist?
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            
          <div className="onetm-page">
          
            <div>
            <h3>Reference Materials</h3>
              <p>Upload and manage your company glossaries and style guides.</p>
            <div >
            {activeTab==="manage" && feature['GLOSSARY_BROWSE_AND_EDIT'] && permission["GLOSSARY_EDIT"] && permission["PROJECT_CUD"] && customer['webGlossaryEnabled'] &&   glossaryLanguage?.length > 0 ?<div className="refrenceRight">
              <button  onClick={() => createProjectRefrence()} className="active dashboard-btn">Translate Glossary</button>
              </div>:Constants.BLANK}
              </div>
            </div>
              <div className="dashboard-top with-auto mar-bot20 flex-center">
                <div className="group-btn flex-center" role="tablist">
                  <button
                    className={
                      activeTab === "manage"
                        ? "active dashboard-btn"
                        : "dashboard-btn"
                    }
                    role="tab"
                    aria-label={activeTab === "manage" ? "Current tab, Manage" : "Manage"}
                    aria-selected={activeTab === "manage" ? "true" : "false"}
                    onClick={() =>setActionManageTab()}
                  >
                    {translate("ref.manage")}
                  </button>
                  {accountPermission?.permissions?.GLOSSARY_EDIT ? (
                  <button
                  id="search-edit-btn"
                    className={
                      activeTab === "searchedit"
                        ? "active dashboard-btn"
                        : "dashboard-btn"
                    }
                    role="tab"
                    aria-label={activeTab === "searchedit" ? "Current tab, Search & Edit" : "Search & Edit"}
                    aria-selected={activeTab === "searchedit" ? "true" : "false"}
                    onClick={() => defaultManageTab(tm?.userGroup?.id)}
                  >
                    {translate("ref.search_edit")}
                  </button>
                     ) :null }

                </div>
              </div>
              <div className={activeTab === "manage" ? "show" : "hide"}>
                <h6 className="mar-bot6">{translate("ref.glossary")}</h6>
                <p className="f14-para">
                  {translate("ref.ref_txt")}&nbsp;
                  <Link onClick={()=>openNewTab("https://cloudwords.zendesk.com/hc/en-us/articles/206359463-Glossary-Search-Edit-And-Add-New-Terms")} ><u>{translate("ref.learn_more")}</u>. </Link> {translate("ref.get_started")} <a href="https://cloudwords.zendesk.com/hc/en-us/article_attachments/201922673" download><u>{translate("ref.glossart_template")}</u></a> &amp; <Link onClick={()=>openNewTab("https://cloudwords.zendesk.com/hc/en-us/articles/206359433-Creating-a-Glossary-Excel-File-to-Upload-to-Cloudwords")}><u>{translate("ref.follow_these_instruction")}</u></Link>.
                </p>
                <div className="white-bg">
                  <div className="table-responsive global-table">
                    <table className="sortable" aria-label="Glossary">
                      <thead>
                        <tr>
                          <th scope="col">{translate("ref.glossary")}</th>
                          <th scope="col">{translate("ref.last_updated_date")}</th>
                          <th scope="col">{translate("ref.last_updated_by")}</th>
                          <th scope="col" className="left-text">{translate("ref.actions")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {tm && tm?.id ? (
                            <>
                              <td
                              >
                                <>
                                {tm?.status==='PROCESSED'?<><Link className="mar-bot6 inline-flex" onClick={()=>setSection(tm?.userGroup?.id)} >Company</Link>
                                <div>
                                    {checkOutOfDate(tm?.userGroup?.id) > 0 &&
                                      <div><Link className="inline-flex flex-align-center" onClick={() =>
                                        setSection(tm?.userGroup?.id, 'NEEDS_UPDATE')
                                      } >                     <span className="inline-flex"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"  width="25" fill="none"
                                      height="25"><path fill="#64748B" d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21Z"  class="color000 svgShape"></path><path fill="#64748B" d="M12,6a1,1,0,0,0-1,1v7a1,1,0,0,0,2,0V7A1,1,0,0,0,12,6Z"  class="color000 svgShape"></path><circle cx="12" cy="17" r="1" fill="#64748B" class="color000 svgShape"></circle></svg>
                                    </span>&nbsp;
                                    <span>{ checkOutOfDate(tm?.userGroup?.id)} terms out of date</span>
                                    </Link>
                                    {tm?.inTranslation?<p>Currently in translation</p>:Constants.BLANK}
                                    </div>}
                                    </div></>:<span>Company</span>}
                                </>
                              </td>
                              <td>
                                <div className="relative text">
                                  <span className="font-zero setFastpass">
                                    <DateFormat date={tm?.lastModifiedDate} />
                                  </span>
                                  <span aria-hidden="true">{tm?.lastModifiedDate ? tmCreatedDate(tm) : ""}
                                  </span>
                                </div>
                              </td>

                              <td> {userGroupData(tm)}

                              </td>
                              <td className="left-text">
                                {tm.status==='PROCESSED'?
                                <div className="flex-center">
                                  {permission?.PROJECT_CUD ? (
                                    <button
                                      onClick={() =>
                                        setSection(tm?.userGroup?.id)
                                      }
                                      className="inline-flex mr-15"
                                      aria-label="Edit"
                                    >
                                      <svg
                                        className="aaa-change-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="18"
                                        viewBox="0 0 14 18"
                                        fill="none"
                                      >
                                        <path
                                          d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z"
                                          fill="#1D4ED8"
                                          stroke="white"
                                          strokeWidth="0.3"
                                        />
                                      </svg>
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  <button
                                    onClick={() =>
                                      download(tm?.contentPath, tm?.userGroup?.id, "company")
                                    }
                                    className="inline-flex mr-15"
                                    aria-label="Download"
                                  >
                                    <svg
                                      className="aaa-change-icon"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="16"
                                      viewBox="0 0 14 16"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z"
                                        fill="#1D4ED8"
                                      />
                                    </svg>
                                  </button>
                                  <button type="button"
                                    onClick={() =>
                                      deleteGlossaryGeneral(
                                        tm?.userGroup?.id,
                                      )
                                    }
                                    className="mr-15 inline-flex" aria-label="delete" >
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                      <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z" fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.3" />
                                    </svg>
                                  </button>

                                  {permission?.PROJECT_CUD ? (
                                    <>
                                      <button
                                        onClick={() =>
                                          {
                                            createTerm(tm?.userGroup?.id)
                                           setStyleGuideDataName("")
                                          }
                                        }
                                        aria-label="Add"
                                        className="inline-flex lastBtn"
                                        >
                                        <svg
                                          className="aaa-change-stroke"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="17"
                                          viewBox="0 0 17 17"
                                          fill="none"
                                        >
                                          <path
                                            d="M8.64062 1V15.72"
                                            stroke="#1D4ED8"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M1.28027 8.36011H16.0003"
                                            stroke="#1D4ED8"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </button>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>:Constants.GLOSSARY_PROCESSING}
                              </td>
                            </>
                          ) : (
                            <>
                              <td

                              >
                                {"Company"}
                              </td>
                              <td></td>
                              <td></td>
                              <td className="left-text">
                                <div className="flex-center">
                                  {permission?.PROJECT_CUD ? (
                                    <>
                                      {getEmptyButtonForLayoutMatch()}
                                      <button
                                        onClick={() =>
                                          {
                                            createTerm(tm?.userGroup?.id)
                                           setStyleGuideDataName("")
                                          }
                                        }
                                        aria-label="Add"
                                        className="inline-flex lastBtn"
                                        >
                                        <svg
                                          className="aaa-change-stroke"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="17"
                                          viewBox="0 0 17 17"
                                          fill="none"
                                        >
                                          <path
                                            d="M8.64062 1V15.72"
                                            stroke="#1D4ED8"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M1.28027 8.36011H16.0003"
                                            stroke="#1D4ED8"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </button></>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>
                            </>
                          )}
                        </tr>
                        {depGroup &&
                          depGroup.length > 0 &&
                          depGroup.map((tm, index) => (
                            <tr key={index}>
                              {tm && tm?.id ? (
                                <>
                                  <td>
                                  {tm.status==='PROCESSED'?
                                  <>
                                    <Link className="mar-bot6 inline-flex" onClick={() =>
                                      setSection(tm?.userGroup?.id)
                                    }>{userGroupName(tm)}</Link>
                                    {checkOutOfDate(tm?.userGroup?.id) > 0 &&
                                      <div><Link className="inline-flex flex-align-center" onClick={() =>
                                        setSection(tm?.userGroup?.id, 'NEEDS_UPDATE')
                                      } >                     <span className="inline-flex"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"  width="25" fill="none"
                                      height="25"><path fill="#64748B" d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21Z"  class="color000 svgShape"></path><path fill="#64748B" d="M12,6a1,1,0,0,0-1,1v7a1,1,0,0,0,2,0V7A1,1,0,0,0,12,6Z"  class="color000 svgShape"></path><circle cx="12" cy="17" r="1" fill="#64748B" class="color000 svgShape"></circle></svg>
                                    </span>&nbsp;<span> { checkOutOfDate(tm?.userGroup?.id)} terms out of date</span></Link>
                                    {tm?.inTranslation?<p>Currently in translation</p>:Constants.BLANK}
                                    </div>
                                    }</>:<span>{userGroupName(tm)}</span>}
                                  </td>
                                  <td>
                                    <div className="relative text">
                                      <span className="font-zero setFastpass">
                                        <DateFormat date={tm?.lastModifiedDate} />
                                      </span>
                                      <span aria-hidden="true">{tm?.lastModifiedDate ? tmCreatedDate(tm) : ""}
                                      </span>
                                    </div></td>
                                  <td> {userGroupData(tm)}

                                  </td>

                                  <td className="left-text">
                                    {tm.status==='PROCESSED'?
                                    <div className="flex-center">
                                      {permission?.PROJECT_CUD ? (
                                        <button
                                          onClick={() =>
                                            setSection(tm?.userGroup?.id)
                                          }
                                          className="inline-flex mr-15"
                                          aria-label="Edit"
                                        >
                                          <svg
                                            className="aaa-change-icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="18"
                                            viewBox="0 0 14 18"
                                            fill="none"
                                          >
                                            <path
                                              d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z"
                                              fill="#1D4ED8"
                                              stroke="white"
                                              strokeWidth="0.3"
                                            />
                                          </svg>
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                      <button
                                        onClick={() =>
                                          download(
                                            tm?.contentPath,
                                            tm?.userGroup?.id,
                                            "department"
                                          )
                                        }
                                        className="inline-flex mr-15"
                                        aria-label="Download"
                                      >
                                        <svg
                                          className="aaa-change-icon"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="14"
                                          height="16"
                                          viewBox="0 0 14 16"
                                          fill="none"
                                        >
                                          <path
                                            d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z"
                                            fill="#1D4ED8"
                                          />
                                        </svg>
                                      </button>
                                      <button
                                        onClick={() =>
                                          deleteGlossaryGeneral(
                                            tm?.userGroup?.id,
                                          )
                                        }

                                        type="button" className="mr-15 inline-flex" aria-label="delete" >
                                        <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                          <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z" fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.3" />
                                        </svg>
                                      </button>
                                      {permission?.PROJECT_CUD ? (
                                        <>
                                          <button
                                            onClick={() =>
                                              {
                                                createTerm(tm?.userGroup?.id)
                                               setStyleGuideDataName("")
                                              }
                                            }
                                            aria-label="Add"
                                            className="inline-flex lastBtn"
                                          >
                                            <svg
                                              className="aaa-change-stroke"
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="17"
                                              height="17"
                                              viewBox="0 0 17 17"
                                              fill="none"
                                            >
                                              <path
                                                d="M8.64062 1V15.72"
                                                stroke="#1D4ED8"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M1.28027 8.36011H16.0003"
                                                stroke="#1D4ED8"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </button>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>:Constants.GLOSSARY_PROCESSING}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td

                                  >
                                    {userGroupName(tm)}
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td className="left-text">
                                    <div className="flex-center">
                                      {permission?.PROJECT_CUD ? (
                                        <>
                                          {getEmptyButtonForLayoutMatch()}

                                          <button
                                            onClick={() => {
                                              createTerm(tm?.userGroup?.id)
                                             setStyleGuideDataName("")
                                            }}
                                            aria-label="Add"
                                            className="inline-flex lastBtn"
                                          >
                                            <svg
                                              className="aaa-change-stroke"
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="17"
                                              height="17"
                                              viewBox="0 0 17 17"
                                              fill="none"
                                            >
                                              <path
                                                d="M8.64062 1V15.72"
                                                stroke="#1D4ED8"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M1.28027 8.36011H16.0003"
                                                stroke="#1D4ED8"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </button></>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </td>
                                </>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className={activeTab === "manage" && permission['STYLEGUIDE_READ_EDIT'] ? "show  mt-5" : "hide"}>
                <h6 className="mar-bot6">Style Guide</h6>
                <p className="f14-para">Having a style guide on OPAL-Marketing helps both your company and your vendors produce content that adheres to your rules about tone, styling, and brand. Once uploaded, all of your teams will have access to the most current style guide for their projects.
                </p>
                <div className="white-bg">
                  <div className="table-responsive global-table">
                    <table className="sortable" aria-label="Style Guide">
                      <thead>
                        <tr>
                          <th scope="col">File Name</th>

                          <th scope="col col">Date</th>
                          <th></th>
                          <th className="align-left" scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {styleGuide ===""?
                        <tr>                        
                          <td>{Constants.STYLE_GUIDE_NOT_PRESENT}</td>
                        <td></td>
                        <td></td>
                        <td className="left-text">
                        <button className="inline-flex mr-15 display-hidden" aria-label="Edit"><svg class="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none"><path d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z" fill="#1D4ED8" stroke="white" stroke-width="0.3"></path></svg></button>
                        <button className="inline-flex mr-15 display-hidden" aria-label="Download"><svg class="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none"><path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8"></path></svg></button>
                        <button className="inline-flex mr-15 display-hidden" aria-label="delete"><svg class="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none"><path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8"></path></svg></button>
                          <button 
                          className="inline-flex lastBtn"
                          onClick={() =>{
                            createTerm()
                           setStyleGuideDataName("Style Guide")
                           setFileDepartmentId(null)
                          }
                          }
                          >
                        <svg
                                          className="aaa-change-stroke"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="17"
                                          viewBox="0 0 17 17"
                                          fill="none"
                                        >
                                          <path
                                            d="M8.64062 1V15.72"
                                            stroke="#1D4ED8"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M1.28027 8.36011H16.0003"
                                            stroke="#1D4ED8"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </button>

                        </td>
                        </tr>:<tr>                        
                          <td className="align-left">{styleGuide?.filename ?styleGuide?.filename:Constants.STYLE_GUIDE_NOT_PRESENT}</td>
                        <td>
                          <div className="relative text">
                            <span className="font-zero setFastpass">
                              <DateFormat date={styleGuide?.createdDate} />
                            </span>
                            <span aria-hidden="true">
                              <DateFormat date={styleGuide?.createdDate} />
                            </span>
                          </div>
                        </td>
                         <td className="align-left"></td>
                        <td className="align-left"><>
                        <div className="flex-center">
                          <button 
                          aria-label="Edit"
                          className="mr-15 inline-flex lastBtn"
                          onClick={() =>
                            {
                              createTerm(styleGuide?.userGroup?.id)
                             setStyleGuideDataName("Replace Style Guide")
                            }
                          }
                          >
<svg
            className="aaa-change-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="18"
            viewBox="0 0 14 18"
            fill="none"
          >
            <path
              d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z"
              fill="#1D4ED8"
              stroke="white"
              strokeWidth="0.3"
            />
          </svg>
                                      </button>
                                     
                                      <button
                                        onClick={() =>
                                          deleteStyleGuideFiles()
                                        }

                                        type="button" className="mr-15 inline-flex" aria-label="delete" >
                                        <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                          <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z" fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.3" />
                                        </svg>
                                      </button>
                                      <button
                                    onClick={() =>
                                      downloadStyleGuideFile(styleGuide?.contentPath, styleGuide?.filename)
                                    }
                                    className="inline-flex mr-15"
                                    aria-label="Download"
                                  >
                                    <svg
                                      className="aaa-change-icon"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="16"
                                      viewBox="0 0 14 16"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z"
                                        fill="#1D4ED8"
                                      />
                                    </svg>
                                  </button>
                                  </div>
                                      </>

                        </td>
                        </tr>}

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className={activeTab === "searchedit" ? "show " : "hide"}>
                <div className="onetm-searchtop flex">
                 <p className="w-full"> Search Glossary</p>
                  <div className="flex wrap-dropdown mb-0">
                    <div className="global-dropdown-block flex-center">
                      <label>Search</label>
                      <div
                        className="global-dropdown-select"
                      >
                        <Select
                          options={glossaryDepartmentData}
                          onChange={event => setDepId(event.value)}
                          classNamePrefix="cw"
                          aria-label="Search"
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                          className="global-dropdown-select"
                          value={glossaryDepartmentData.filter(data => data?.value === depId)}
                        />
                      </div>
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>For</label>
                      <div
                        className="global-dropdown-select global-dropdown-block global-multidropdown-check mb-0"
                      >
                        <ReactMultiSelect 
                        ref={multiSelectRef} 
                        value={valueForMultiSelect} 
                        option={transaltionType} 
                        callback={handleTranslationChange}
                        ariaLabel={'For'}
                        placeholder={'Select'}
                        inputChange={handleInputChange}
                        />
                       
                      </div>
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Target Language</label>
                      <div
                        className="global-dropdown-select global-dropdown-block global-multidropdown-check mb-0"
                      >
                        <ReactMultiSelect 
                        ref={multiSelectRef1} 
                        value={selectedLanguage} 
                        option={departmentGlossaryLanguage} 
                        callback={handleLanguageChange}
                        ariaLabel={'Target Language'}
                        placeholder={'Select'}
                        inputChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex-center flex-right">
                    <button id="search-btn" disabled={depId == null} onClick={() => getBrowseGlossary(1, size)} className="active dashboard-btn">Search</button>
                    <button className="dashboard-btn" onClick={rightModel} id="AdditionalFilter" aria-expanded={rightModelStatus?"true":"false"}>
                      <span className="filter-icon">
                        <svg
                          width="19"
                          height="14"
                          viewBox="0 0 19 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z"
                            fill="#1D4ED8"
                          ></path>
                        </svg>
                      </span>{" "}
                      Filters
                    </button>
                  </div>
                </div>
                <div className="white-bg">
                  {/* {size*(currentPage-1)} - {size*(currentPage+1)} */}
                  {pageCount > 0 &&
                  <>
                    <div className="flex search-heading mar-bot20">

                      <span id="searchResults">Showing {pageCount > size ? `${size} of` : ""} {pageCount} terms</span>
                      <a tabIndex={0} onClick={allGlossarydownload} onKeyDown={(e)=>{if (e.key === Constants.ENTER) {allGlossarydownload()}}}>
                      <strong>
                        Download
                        <svg
                          className="aaa-change-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="11"
                          viewBox="0 0 10 11"
                          fill="none"
                        >
                          <path
                            d="M5.02273 11L9.8897 6.41955C9.96485 6.33696 10.0041 6.23072 9.99966 6.12207C9.9952 6.01342 9.94734 5.91036 9.86565 5.83347C9.78395 5.75658 9.67444 5.71154 9.55899 5.70735C9.44354 5.70315 9.33066 5.74011 9.24291 5.81083L5.48144 9.34655V0.431711C5.48144 0.317214 5.43311 0.207407 5.34709 0.126445C5.26106 0.0454838 5.14439 0 5.02273 0C4.90107 0 4.78439 0.0454838 4.69837 0.126445C4.61234 0.207407 4.56401 0.317214 4.56401 0.431711V9.34655L0.80713 5.81083C0.766008 5.76564 0.715403 5.72894 0.658493 5.70302C0.601582 5.67711 0.539595 5.66255 0.476421 5.66025C0.413247 5.65796 0.35025 5.66797 0.291386 5.68968C0.232521 5.71138 0.179059 5.7443 0.134355 5.78638C0.0896507 5.82845 0.0546701 5.87876 0.0316083 5.93416C0.00854662 5.98956 -0.00209831 6.04885 0.000341825 6.1083C0.00278196 6.16776 0.0182545 6.2261 0.0457881 6.27966C0.0733217 6.33322 0.112322 6.38084 0.160341 6.41955L5.02273 11Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                      </strong>
                      </a>
                    </div>
                    <div className="flex gap20 mar-bot20 reference-inline">
                    <div className="addNew-term">
                      <button onClick={addNewTerm} aria-expanded={status ? "true" : "false"} className="blue-btn active">
                        Add New Term{" "}
                      </button>{" "}
                    </div>


                        <div className="global-dropdown-block mb-0">
                          <Select
                            onChange={(event) => bulkUpdateGlossaryStatus(event)}
                            options={Status}
                            placeholder="Update Status"
                            aria-label="Status"
                            className="global-dropdown-select"
                            menuShouldScrollIntoView={false}
                            value={Status?.filter(data=>data?.value===updatedStatus?.value)}
                            closeMenuOnSelect={true}
                            isDisabled={isDisabled()}
                            classNamePrefix='cw'
                          /></div>
                        <button disabled={!selectSourceTerms?.length} onClick={bulkDelteGlossary} className="blue-btn">
                          Delete Term{" "}
                        </button>
                        &nbsp;
                  </div>
                  </>
                  }

                  
                  {status ? (
                    <div className="">
                      <div className="flex wrap-dropdown space-gap">
                        <div className="global-dropdown-block m-0"><input
                          id="addSourceTerm"
                          onChange={(event) =>
                            setSourceTerm(event?.target?.value)
                          }
                          className="form-control-sm"
                          type="text"
                          placeholder="Source Term"
                          aria-required="true"
                        /></div>{" "}

                        <div className="global-dropdown-block m-0"><Select
                          onChange={(event) => setPartOfspeech(event)}
                          options={partOfSpeech}
                          placeholder="Part of Speech"
                          aria-label="Part of Speech"
                          className="global-dropdown-select"
                          menuShouldScrollIntoView={false}
                          isClearable={true}
                          closeMenuOnSelect={true}
                          classNamePrefix='cw'
                        /></div></div>
                      <div className="flex wrap-dropdown space-gap">
                        <div className="global-dropdown-block m-0"><Select
                          onChange={(event) => setStatusSourceTerm(event)}
                          options={Status}
                          placeholder="Status"
                          aria-label="Status"
                          isClearable={true}
                          className="global-dropdown-select"
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                          classNamePrefix='cw'
                        /></div>

                        <div className="global-dropdown-block m-0"><input
                          onChange={(event) => setNotes(event?.target?.value)}
                          className="form-control-sm"
                          type="text"
                          placeholder="Notes"
                        /></div></div>{" "}

                      <div className="flex min-width77 gap20 mar-bot20">
                        <button onClick={newSourceTerm} className="blue-btn active">
                          Save{" "}
                        </button>{" "}

                        <button onClick={cancelSourceTerm} className="blue-btn">
                          Cancel
                        </button>
                      </div>
                      {sourceErrorMsg !=="" && <span className="textDanger">{sourceErrorMsg}</span>}
                    </div>
                  ) : (
                    ""
                  )}

                  <div id="refernce_table" className="datatable-block">
                    <DataTable
                      columns={columns}
                      data={browseGlossaryData}
                      pagination
                      selectableRows
                      highlightOnHover
                      responsive
                      striped
                      selectableRowsHighlight
                      onSelectedRowsChange={handleRowSelected}
                      progressPending={globalOverlay}
                      keyField="id"
                      fixedHeader
                      paginationServer
                      paginationTotalRows={pageCount}
                      paginationPerPage={15}
                      onChangeRowsPerPage={handlePerRowsChange}
                      paginationRowsPerPageOptions={[15, 30, 50, 150]}
                      onChangePage={handlePageChange}
                      defaultSortFieldId={1}
                      clearSelectedRows={toggleCleared}
                      noDataComponent={noDataFoundComponent()}
                      dense
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>:collectionExistErrorMessage}
        </section>
      </div>
      {conditionalpopup ? (
        <div className="lightbox-panel" aria-labelledby="termsDetails" aria-modal="true" role="dialog"
        onKeyDown={(e)=>termDetailsKeydown(e)}
        >
          <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="termsDetails">Terms Details</h5>
              <button
                className="close"
                aria-label="close"
                onClick={hideModel}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                    fill="white"
                  ></path>
                  <path
                    d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                    fill="white"
                  ></path>
                </svg>
              </button>
            </div>
            <div className="lightbox-content padd-22">
              <ul className="translation-onetm-list">
                <li>
                  <strong>Source Term Status</strong>
                  <span>{details?.status?.display}</span>
                </li>
                <li>
                  <strong>{selectedSourceLanguage?.sourceLanguage?.displayName} Source</strong>
                  <span>{details?.sourceTerm?.text}</span>
                </li>
                <li>
                  <strong>Part of Speech</strong>
                  <span>{ partOfSpeechDisplay[details?.sourceTerm?.partOfSpeech] }</span>
                </li>
                <li>
                  <strong>Notes</strong>
                  <span>{details?.notes}</span>
                </li>
                {termsLanguages.map((data,index) => (
                  <li key={index}>
                    <strong>{data?.displayName}</strong>
                    <span>{data?.text}</span>
                  </li>
                ))}
                <li>
                  <strong>Created By</strong>
                  <span>
                    <div className="relative text">
                      <span className="font-zero setFastpass">
                        <DateFormat date={details?.createdDate} format={DATE_FORMATS.SHORT_DATE_TIME} />
                      </span>
                      <span aria-hidden="true">
                        <DateFormat date={details?.createdDate} format={DATE_FORMATS.DATE_TIME} />
                      </span>
                    </div>
                    </span>
                </li>
                <li>
                  <strong>Most Recent Activity</strong>
                    <div className="relative text">
                      <span className="font-zero setFastpass">
                        <DateFormat date={details?.lastModifiedDate} format={DATE_FORMATS.SHORT_DATE_TIME} />
                      </span>
                      <span aria-hidden="true">
                        <DateFormat date={details?.lastModifiedDate} format={DATE_FORMATS.DATE_TIME} />
                      </span>
                    </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div className="lightbox-panel medium-panel" aria-labelledby="new_term" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              {styleGuideName ===""?<h5 id="new_term">{translate("ref.new_term")}</h5>:<h5 id="new_term">{styleGuideName}</h5>}
              <button
                id="hideNewTermModal"
                className="close"
                disabled={lasChunkStatus}
                aria-label="close popup"
                onClick={() => hideModalReference(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                    fill="white"
                  ></path>
                  <path
                    d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                    fill="white"
                  ></path>
                </svg>
              </button>
            </div>
            <div className="lightbox-content padd-22">
              <div className="upload-file-container">
                <div className="upload-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                  >
                    <path
                      d="M31.125 34C31.125 34 38.398 34 39.0857 34C42.9051 34 46 30.8778 46 27.0255C46 23.1733 42.9051 20.0502 39.0857 20.0502C39.0682 20.0502 39.0525 20.0528 39.035 20.0528C39.0884 19.6168 39.1251 19.1754 39.1251 18.7252C39.1251 12.8021 34.366 8 28.4939 8C23.9185 8 20.0309 10.921 18.5311 15.0098C17.58 14.0485 16.264 13.4526 14.8115 13.4526C11.9074 13.4526 9.55363 15.8272 9.55363 18.7561C9.55363 18.8311 9.56238 18.9035 9.565 18.9777C6.35813 19.8719 4 22.8281 4 26.3476C4 30.5741 7.39588 34 11.5863 34C12.3099 34 18.875 34 18.875 34"
                      stroke="#96ACCC"
                      strokeWidth="2.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M21 28L25 23L29 28"
                      stroke="#96ACCC"
                      strokeWidth="2.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                    ></path>
                    <path
                      d="M25 41V24"
                      stroke="#96ACCC"
                      strokeWidth="2.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                    ></path>
                  </svg>
                </div>
                <div className="upload-format flex-column">
              {styleGuideName ===""?
                  
                  <p>
                    {translate("ref.excel_format")} <br />
                    {translate("ref.upload_multiple")} {translate("ref.zip_file")}
                    ({accountPermission?.maxFileUploadSizeGb} GB or less).
                  </p>:<p>
                    {translate("You can upload a file of any type. Create a .zip file to upload multiple files " +accountPermission?.maxFileUploadSizeGb+ " GB or less .")} 
                  </p>}
                  
                  {!fileUploadStatus?
                  <div className="file-drag">
                    {translate("ref.drag_drop")}
                  </div>:Constants.BLANK}
                </div>
                <div className="input-file-container">
                  {!fileUploadStatus?
                  <div className="input-file">
                    <input
                      type="file"
                      id="files"
                      className="first-focus"
                      onChange={(e) => fileSelection(e)}
                      onClick={(e) => clearValue(e)}
                      aria-labelledby="uploadError"
                    />
                    <label className="file-button " htmlFor="files">
                      {selectedfile === "" ? translate("ref.choose_file") : translate("ref.replace_file")}
                    </label>
                  </div>:Constants.BLANK}
                  <span className="textDanger" id="uploadError">{fileUploadRes}</span>
                  <span className="success">{uploadStatus}</span>

                  {uploadStatus && uploadStatus.length > 0 &&
                    <div className="mt-2">
                      <button id="hideUploadModal" className="btn" aria-label={uploadStatus + " close"} onClick={() => hideModalReference(true)} onKeyDown={(e)=>keydownhandling(e)}>
                        Close
                      </button>
                    </div>
                  }

                  <div className="gb-upload-files files">
                    {files.map((file, fileIndex) => {
                      let progress = 0;
                      if (file.finalFilename) {
                        progress = 100;
                      } else {
                        const uploading = fileIndex === currentFileIndex;
                        const chunks = Math.ceil(file.size / chunkSize);
                        if (uploading) {
                          progress = Math.round(
                            (currentChunkIndex / chunks) * 100
                          );
                        } else {
                          progress = 0;
                        }
                        if (chunks === 1) {
                          progress = 50;
                        }
                      }
                      return (
                        <div className="show-flex flex-center multiple-files">
                          <div className="icon-block">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              viewBox="0 0 25 25"
                              fill="none"
                            >
                              <path
                                d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                fill="#EA6404"
                              ></path>
                            </svg>
                          </div>
                          <div className="right-progressbar">
                            <label>{file.name}</label>
                            <CustomProgressBar
                              completed={progress !== "" ? progress : 0}
                              labelLineHeight="1px"
                              labelSize="14px"
                              width="100%"
                              labelClassName="progressBarLabel"
                              borderRadius="30px"
                              labelAlignment="outside"
                              labelColor="rgba(0,0,0,0.87)"
                              height="6px"
                              className="campaign_progress"
                              bgColor="#06B878"
                              baseBgColor="#D1DEF0"
                              ariaValuetext={progress !== "" ? progress : 0}
                              aria-label=""
                              aria-valuenow={progress !== "" ? progress : 0}
                            />
                          </div>
                        </div>
                      );
                    })}

                    {fileQueue.current.map((file, fileIndex) => {
                      return (
                        <div className="show-flex flex-center multiple-files">
                          <div className="icon-block">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              viewBox="0 0 25 25"
                              fill="none"
                            >
                              <path
                                d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                fill="#EA6404"
                              ></path>
                              <path
                                d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                fill="#EA6404"
                              ></path>
                            </svg>
                          </div>
                          <div className="right-progressbar">
                            <label>{file.name}</label>
                            <CustomProgressBar
                              completed={0}
                              labelSize="14px"
                              labelLineHeight="1px"
                              width="100%"
                              labelClassName="progressBarLabel"
                              borderRadius="30px"
                              labelAlignment="outside"
                              labelColor="rgba(0,0,0,0.87)"
                              height="6px"
                              className="campaign_progress"
                              bgColor="#06B878"
                              baseBgColor="#D1DEF0"
                              ariaValuetext={0}
                              aria-label=""
                              aria-valuenow={0}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="upload-file-ext flex-center">
                    <div className="inline-flex">
                      <strong
                        className={selectedfile ? "show-flex" : "hide"}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                        >
                          <path
                            d="M6.71373 3.85714V2.57143H5.42801V3.85714H6.71373ZM7.99944 5.14286V3.85714H6.71373V5.14286H7.99944ZM6.71373 6.42857V5.14286H5.42801V6.42857H6.71373ZM7.99944 7.71429V6.42857H6.71373V7.71429H7.99944ZM15.0307 3.81696C15.2182 4.00446 15.3789 4.25893 15.5128 4.58036C15.6468 4.90179 15.7137 5.19643 15.7137 5.46429V17.0357C15.7137 17.3036 15.62 17.5312 15.4325 17.7188C15.245 17.9062 15.0173 18 14.7494 18H1.24944C0.981585 18 0.753906 17.9062 0.566406 17.7188C0.378906 17.5312 0.285156 17.3036 0.285156 17.0357V0.964286C0.285156 0.696429 0.378906 0.46875 0.566406 0.28125C0.753906 0.09375 0.981585 0 1.24944 0H10.2494C10.5173 0 10.8119 0.0669643 11.1334 0.200893C11.4548 0.334821 11.7093 0.495536 11.8968 0.683036L15.0307 3.81696ZM10.5709 1.36607V5.14286H14.3477C14.2807 4.94866 14.207 4.81138 14.1267 4.73103L10.9827 1.58705C10.9023 1.5067 10.7651 1.43304 10.5709 1.36607ZM14.428 16.7143V6.42857H10.2494C9.98158 6.42857 9.75391 6.33482 9.56641 6.14732C9.37891 5.95982 9.28516 5.73214 9.28516 5.46429V1.28571H7.99944V2.57143H6.71373V1.28571H1.57087V16.7143H14.428ZM8.13002 9.4721L9.2048 12.9777C9.25837 13.1585 9.28516 13.3326 9.28516 13.5C9.28516 14.0558 9.04241 14.5162 8.55692 14.8811C8.07143 15.2461 7.45703 15.4286 6.71373 15.4286C5.97042 15.4286 5.35603 15.2461 4.87054 14.8811C4.38504 14.5162 4.1423 14.0558 4.1423 13.5C4.1423 13.3326 4.16908 13.1585 4.22266 12.9777C4.36328 12.5558 4.76507 11.2299 5.42801 9V7.71429H6.71373V9H7.50725C7.65458 9 7.78516 9.04353 7.899 9.13058C8.01283 9.21763 8.08984 9.33147 8.13002 9.4721ZM6.71373 14.1429C7.06864 14.1429 7.37165 14.0792 7.62277 13.952C7.87388 13.8248 7.99944 13.6741 7.99944 13.5C7.99944 13.3259 7.87388 13.1752 7.62277 13.048C7.37165 12.9208 7.06864 12.8571 6.71373 12.8571C6.35882 12.8571 6.0558 12.9208 5.80469 13.048C5.55357 13.1752 5.42801 13.3259 5.42801 13.5C5.42801 13.6741 5.55357 13.8248 5.80469 13.952C6.0558 14.0792 6.35882 14.1429 6.71373 14.1429Z"
                            fill="#157EFB"
                          ></path>
                        </svg>
                      </strong>
                      <span>{selectedfile?.name} {!fileUploadPermission ?Constants.BLANK:formatBytes(selectedfile?.size)}</span>
                    </div>
                  </div>
                  <div
                    className={
                      "error upload-error" +
                      (showError === true ? " show" : " hide")
                    }
                  >
                    Upload Failed: Our Apologies. One or more files in the
                    zip is not supported by OPAL-Marketing.
                  </div>
                  {!fileUploadPermission ? 
                  <button
                    id="valid-upload"
                    className={selectedfile ? "btn" : "btn disabled hide"}
                    disabled={selectedfile ? false : true}
                    onClick={(e) => handleFileSelect(e)}
                  >
                    Validate &amp; Upload
                  </button>:<span className="textDanger">File size exceeds {accountPermission.maxFileUploadSizeGb} GB.</span>}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="overlay rightpopup-conditional"></div>
      {rightModelStatus ?
      <div className="right-modal onetm-right-modal rightpopup-conditional-model">
        <div className="modal-header flex">
          <div className="left flex-center">
            <strong>Additional Filters</strong>
          </div>
          <button
            className="close flex-center closeAdditionalFilter"
            aria-label="close"
            onClick={hideRightModel}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                fill="white"
              ></path>
              <path
                d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                fill="white"
              ></path>
            </svg>
          </button>
        </div>
        <div className="modal-content project-filter-content">
          <div className="filter-selector">
            <div className="global-dropdown-block mar-bot20">
              <div className="global-dropdown-select w-d100">
                <Select
                  onChange={event => setLastUpdateDate(event)}
                  options={ModifiedWithin}
                  value={lastUpdateDate}
                  isClearable={true}
                  placeholder="Last updated date"
                  aria-label="Last updated date"
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  classNamePrefix='cw'
                />
              </div>
            </div>
            <div className="global-dropdown-block mar-bot20">
              <div className="global-dropdown-select w-d100">
                <Select onChange={event => setTermStatus(event)} options={Status}
                  placeholder="Source Term Status"
                  value={termStatus}
                  aria-label="Source Term Status"
                  isClearable={true}
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  classNamePrefix='cw'
                />
              </div>
            </div>
            <div className="global-dropdown-block mar-bot20">
              <div className="global-dropdown-select w-d100">
                <Select onChange={event => setPartOfSpeechFilter(event)} options={partOfSpeechFilterList}
                  placeholder="Part of Speech"
                  aria-label="Part of Speech"
                  value={partOfSpeechFilter}
                  isClearable={true}
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  classNamePrefix='cw'
                />
              </div>
            </div>
            <div className="global-dropdown-block mar-bot20">
              <div className="global-dropdown-select w-d100">
                <input onChange={event => setContainWord(event?.target?.value)} value={containWord} type="text" placeholder="Contains word" className="form-control-sm" />
              </div>
            </div>
            
              <div className="global-dropdown-block mar-bot20">
                <div className="global-dropdown-select w-d100">
                  <Select 
                    isDisabled={containWord === "" || containWord===null}
                    onChange={event => setTranslationLanguage(event)} options={allLanguage}
                    placeholder="Any Language"
                    aria-label="Any Language"
                    value={translationLanguage}
                    isClearable={true}
                    menuShouldScrollIntoView={false}
                    closeMenuOnSelect={true}
                    classNamePrefix='cw'
                  />
                </div>
              </div>
            <div className="global-dropdown-block mar-bot20">
              <div className="global-dropdown-select w-d100">
                <Select onChange={event => setUser(event)} options={customerUser}
                  placeholder="Last modified by"
                  aria-label="Last modified by"
                  menuShouldScrollIntoView={false}
                  value={user}
                  isClearable={true}
                  closeMenuOnSelect={true}
                  classNamePrefix='cw'
                />
              </div>
            </div>

            <div className="button-group flex">
              <button id="cancelRightModal" className="btn default-btn" onClick={hideRightModel}>
                Cancel
              </button>
              <button id="additionSaveBtn" onClick={applyButtonClick} className="btn">Apply</button>
            </div>
          </div>
        </div>
      </div> : ""}
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>
      {(successMessage !== undefined && successMessage !== Constants.BLANK) ? <SuccessMessage message={successMessage} /> : Constants.BLANK}
     
    </div>
  );
}
